import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getQuoteData, getSinglePackage, createQuote } from "../../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import Select from "react-select";
import { useSelector } from "react-redux";
import { Trash2 } from 'lucide-react';
import debounce from 'lodash.debounce';
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { agentDetails } from "../../../ReduxStore/Slice/Auth/AuthSlice";

const StepTwo = ({ formData, handleChange, nextStep, prevStep, currentStep }) => {

  // console.log("StepTwo formData", formData);
  // console.log("StepTwo formData", formData.quoteid);

  const location = useLocation();
  const dispatch = useDispatch();
  let QuoteId = sessionStorage.getItem("quote_id");

  if (location.state != undefined && location.state != null && location.state.record_id == undefined) {
    sessionStorage.setItem("quote_id", location.state.row.id);
    QuoteId = location.state.row.id;
  }
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  // console.log("location", location);



  let backupQuoteId = QuoteId;

  if (formData != undefined && formData.quoteid != undefined) {
    backupQuoteId = formData.quoteid;
  }

  if (location.state != null && location.state.row.id != undefined) {
    backupQuoteId = location.state.row.id;
  }






  let paymentMethodsArray = [];
  const agent_payment_settings = JSON.parse(localStorage.getItem("agent_payment_settings"));
  if (agent_payment_settings != null && agent_payment_settings != undefined && typeof agent_payment_settings == 'object') {
    paymentMethodsArray = Object.values(agent_payment_settings);
  }

  const [serviceTypeForQuote, setServiceTypeForQuote] = useState("");

  const [isSelfAssessmentChargeBasis, setIsSelfAssessmentChargeBasis] = useState(false);
  const [needSelfAssessmentRadio, setNeedSelfAssessmentRadio] = useState(0);
  const [selfAssessmentCount, setSelfAssessmentCount] = useState(0);
  const individuals = Array.from({ length: selfAssessmentCount }, (_, i) => `Individual ${i + 1}`);
  //console.log("individuals", individuals)
  const [quoteEnterDefaultValue, setQuoteEnterDefaultValue] = useState([]);

  // console.log("quoteEnterDefaultValue", quoteEnterDefaultValue)
  const [quoteIndividualSetValue, setQuoteIndividualSetValue] = useState([]);
  // console.log("quoteIndividualSetValue", quoteIndividualSetValue)


  const [showDiscount, setShowDiscount] = useState("0");
  const [showPrice, setShowPrice] = useState("0");


  // Package
  const [packageID, setPackageID] = useState(null);
  const [packagesServiceData, setPackagesServiceData] = useState([]);

  // console.log("packagesServiceData", packagesServiceData)

  // OnGoing Input
  const [discount, setDiscount] = useState(0);
  const [premium, setPremium] = useState(0);
  const [discount_exist, setDiscount_exist] = useState(0);
  const [defaultPrice_exist, setDefaultPrice_exist] = useState(0);
  const [status_discount, setStatus_discount] = useState('1');
  const [max_discount, setMax_discount] = useState(0);
  const [agentConfigSetting, setAgentConfigSetting] = useState({});


  // console.log("agentConfigSetting", agentConfigSetting)

  const [paymentTerm, setPaymentTerm] = useState("");
  const [qualifyPackages, setQualifyPackages] = useState([]);

  const [quoteData, setQuoteData] = useState({
    quote: [],
    chargeBasisQuery: [],
    onOffServices: [],
    onGoingServices: [],
    packages: [],
  });

  // OnGoing Input
  const [max_discountAgent, setMax_discountAgent] = useState(null);
  const [serviceData, setServiceData] = useState([]);
  const [addedService, setAddedService] = useState([]);

  //  console.log("serviceData", serviceData)


  const [agentData, setAgentData] = useState({});
  const [showModalPaymentTerm, setShowModalPaymentTerm] = useState(false);
  const [paymentTypeOfModal, setPaymentTypeOfModal] = useState("");



  const handleCloseModal = () => {
    setShowModalPaymentTerm(false);
  };



  // Quote Complexity Slider
  const [sliderValueComplexity, setSliderValueComplexity] = useState([0, 2]);
  const [selectedLabelComplexity, setSelectedLabelComplexity] = useState('Default');
  const [complexityValue, setComplexityValue] = useState(0);
  const levels = {
    Default: 2,
    Low: 34,
    Medium: 65,
    High: 99
  };

  const handleLabelComplexityClick = (label) => {
    // console.log("agentConfigSetting", agentConfigSetting)
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

      if (label === 'Default') {
        setComplexityValue(0);
      } else if (label === 'Low') {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_low || 0));
      } else if (label === 'Medium') {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_medium || 0));
      } else if (label === 'High') {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_high || 0));
      }
      setSelectedLabelComplexity(label);
      setSliderValueComplexity([0, levels[label]]);
    } else {
      setComplexityValue(0);
      setSelectedLabelComplexity('Default');
      setSliderValueComplexity([0, 2]);
    }
  };

  const handleSliderComplexityClick = (e) => {
    const sliderRect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - sliderRect.left;
    const sliderWidth = sliderRect.width;
    const percentage = (clickX / sliderWidth) * 100;
    // console.log("percentage", percentage);

    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

      if (percentage < 32) {
        setComplexityValue(0);
        setSelectedLabelComplexity('Default');
        setSliderValueComplexity([0, 2]);
      }
      else if (percentage >= 32 && percentage < 61) {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_low || 0));
        setSelectedLabelComplexity('Low');
        setSliderValueComplexity([0, 34]);
      }
      else if (percentage >= 61 && percentage < 86) {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_medium || 0));
        setSelectedLabelComplexity('Medium');
        setSliderValueComplexity([0, 65]);
      }
      else if (percentage >= 86 && percentage < 100) {
        setComplexityValue(parseFloat(agentConfigSetting.complexity_high || 0));
        setSelectedLabelComplexity('High');
        setSliderValueComplexity([0, 99]);
      }
    } else {
      setComplexityValue(0);
      setSelectedLabelComplexity('Default');
      setSliderValueComplexity([0, 2]);
    }
  }

  // Quote Risk Slider End
  const [sliderValueRisk, setSliderValueRisk] = useState([0, 2]);
  const [selectedLabelRisk, setSelectedLabelRisk] = useState('Default');
  const [riskValue, setRiskValue] = useState(0);

  const handleLabelRiskClick = (label) => {
    // console.log("agentConfigSetting", agentConfigSetting)
    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (label === 'Default') {
        setRiskValue(0);
      } else if (label === 'Low') {
        setRiskValue(parseFloat(agentConfigSetting.risk_low || 0));
      }
      else if (label === 'Medium') {
        setRiskValue(parseFloat(agentConfigSetting.risk_medium || 0));
      } else if (label === 'High') {
        setRiskValue(parseFloat(agentConfigSetting.risk_high || 0));
      }
      setSelectedLabelRisk(label);
      setSliderValueRisk([0, levels[label]]);
    }
    else {
      setRiskValue(0);
      setSelectedLabelRisk('Default');
      setSliderValueRisk([0, 2]);
    }
  };

  const handleSliderRiskClick = (e) => {
    const sliderRect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - sliderRect.left;
    const sliderWidth = sliderRect.width;
    const percentage = (clickX / sliderWidth) * 100;
    // console.log("percentage", percentage);

    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {
      if (percentage < 32) {
        setRiskValue(0);
        setSelectedLabelRisk('Default');
        setSliderValueRisk([0, 2]);
      }
      else if (percentage >= 32 && percentage < 61) {
        setRiskValue(parseFloat(agentConfigSetting.risk_low || 0));
        setSelectedLabelRisk('Low');
        setSliderValueRisk([0, 34]);
      }
      else if (percentage >= 61 && percentage < 86) {
        setRiskValue(parseFloat(agentConfigSetting.risk_medium || 0));
        setSelectedLabelRisk('Medium');
        setSliderValueRisk([0, 65]);
      }
      else if (percentage >= 86 && percentage < 100) {
        setRiskValue(parseFloat(agentConfigSetting.risk_high || 0));
        setSelectedLabelRisk('High');
        setSliderValueRisk([0, 99]);
      }
    } else {
      setRiskValue(0);
      setSelectedLabelRisk('Default');
      setSliderValueRisk([0, 2]);
    }

  }


  // console.log("agentConfigSetting", agentConfigSetting)
  // console.log("selectedLabelComplexity", selectedLabelComplexity)
  // console.log("complexityValue", complexityValue)
  // console.log("riskValue", riskValue)
  // console.log("selectedLabelRisk", selectedLabelRisk)


  const increasePremium = parseFloat(complexityValue) + parseFloat(riskValue);
  const increasePremiumFinal = parseFloat(complexityValue) + parseFloat(riskValue) + parseFloat(premium || 0);

  // console.log("increasePremium", increasePremium)


  let containsGoCardless = false;
  let paymentTermTypeGetAgent = [];
  if (agentData.agent_payment_settings != undefined) {
    //console.log("agentData agent_payment_settings --- ", JSON.parse(agentData.agent_payment_settings));
    let dataAgentPaymentSetting = JSON.parse(agentData.agent_payment_settings);
    containsGoCardless = Object.keys(dataAgentPaymentSetting).includes("GoCardless");
    // paymentTermTypeGetAgent = Object.keys(dataAgentPaymentSetting).filter(key => key !== "GoCardless");
    paymentTermTypeGetAgent = Object.entries(dataAgentPaymentSetting)
      .filter(([key]) => key !== "GoCardless")
      .map(([key, value]) => ({
        label: value.lable,
        value: key
      }));
  }

  let paymentTypeLable = paymentTermTypeGetAgent.find(item => item.value === paymentTypeOfModal)?.label;


  useEffect(() => {

    setAddedService((prev) =>
      prev.map((item) => {
        const price = servicePriceCalculation(item);
        return {
          ...item,
          price,
        };
      })
    );
  }, [quoteEnterDefaultValue, quoteIndividualSetValue, selfAssessmentCount]);

  const getAgentList = async () => {
    const req = { agent_id: agent_id }
    await dispatch(agentDetails(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          //console.log("res -- agents details", res)
          setAgentData(res.data);
          if (res.data.adhoc_max_discount != null && res.data.adhoc_max_discount != undefined && res.data.adhoc_max_discount != "") {
            setMax_discountAgent(parseFloat(res.data.adhoc_max_discount));
          }
        }
        else {
        }
      })
      .catch((err) => {
        console.log("Error", err)
      })
  }

  useEffect(() => {
    getAgentList();
    getQuoteCallFirstTime();
  }, []);

  const setServiceTypeForQuoteChangeFun = async (e) => {
    let { value } = e.target;
    setPackageID(null);
    setPackagesServiceData([]);
    setDiscount(0);
    setPremium(0);
    setDiscount_exist(0);
    setStatus_discount('1');
    setMax_discount(0);
    setServiceData([]);
    setPaymentTerm("");
    setPaymentTypeOfModal("");

    // if (containsGoCardless == false) {
    //   setPaymentTerm("100_upfront");
    // } else {
    //   setPaymentTerm("monthly_dd");
    // }

    setServiceTypeForQuote(value);
    setAddedService([]);
    setPackageID(null);
    setPackagesServiceData([]);



    if (value == "1" || value == "2") {
      await getQuoteReSelect(value)
      setPaymentTerm("");
      setPaymentTypeOfModal("");
      // if (containsGoCardless == false) {
      //   setPaymentTerm("100_upfront");
      // } else {
      //   setPaymentTerm("monthly_dd");
      // }

    } else {
      setServiceTypeForQuote("");
      setIsSelfAssessmentChargeBasis(false)
      setQuoteData({
        quote: [],
        chargeBasisQuery: [],
        onOffServices: [],
        onGoingServices: [],
        packages: [],
      });
    }
  };

  const UpdatedQuoteEnterDefualt = async (existingData, masterData) => {
    const updatedMasterData = masterData.map((item) => {
      // upar wale array me matching item dhundo
      const match = existingData.find((ex) =>
        ex.chargebasis_id === item.chargebasis_id
      );

      if (match) {
        return {
          ...item,
          inputValue: match.inputValue, // inputValue upar wale se lo
          chargetype_rule_id: match.chargetype_rule_id ?? item.chargetype_rule_id, // agar upar wale me chargetype_rule_id ho to overwrite
        };
      }

      return item; // agar match nahi mile to waise ka waise
    });


    setQuoteEnterDefaultValue(updatedMasterData);
    return updatedMasterData
    // Quote Enter Default Value Set ------------->
  };

  const UpdateIndividualSetValue = async (quoteIndividuals, allChargeBases) => {
    // Step 1: Flatten all QuoteIndividualSetValues with name
    const flattened = [];

    quoteIndividuals.forEach(individual => {
      const name = individual.name;
      individual.QuoteIndividualSetValues.forEach(setValue => {
        flattened.push({
          chargebases_id: setValue.chargebases_id,
          inputValue: setValue.inputValue,
          radio_option: setValue.radio_option,
          name: name
        });
      });
    });

    // Step 2: Group by chargebases_id
    const grouped = {};

    flattened.forEach(item => {
      if (!grouped[item.chargebases_id]) {
        grouped[item.chargebases_id] = {
          chargebases_id: item.chargebases_id,
          individual: []
        };
      }
      grouped[item.chargebases_id].individual.push({
        name: item.name,
        inputValue: item.inputValue,
        radio_option: item.radio_option
      });
    });

    // Step 3: Add name and basistypes_id using reference (like chargeBasis list)
    const transformed = Object.values(grouped).map(item => {
      const reference = allChargeBases.find(cb => cb.id === item.chargebases_id) || {};
      //console.log("reference -- ", reference)
      return {
        ...item,
        name: reference.name || null,
        basistypes_id: reference.basistypes_id || null
      };
    });

    //console.log("UPDATEDDDD SET ALUE",transformed);

    setQuoteIndividualSetValue(transformed);

    return transformed

  };

  const UpdatedServiceOnly = async (input) => {

    let serviceOnly = input.some(item => item.package_id == null);
    // console.log("serviceOnly -- ", serviceOnly)
    if (serviceOnly == false) {
      return
    }
    // Convert
    const output = input.map(item => {
      const service = { ...item.Service };

      service.ServiceChargeBases = service.ServiceChargeBases.map(base => ({
        ...base,
        service_id: service.id,
        chargebasis_id: base.ChargeBasis.id
      }));

      return {
        ...service,
        price: item.price,
        sell_chargebasis_id: item.sell_chargebasis_id
      };
    });

    setAddedService(output);
    setServiceData(output.map(item => ({
      value: item.id,
      label: item.name,
    })));

  };

  const UpdatedPackageService = async (input, res) => {

    let PackageService = input.some(item => item.package_id !== null);
    // console.log("serviceOnly -- ", serviceOnly)
    if (PackageService == false) {
      return
    }
    let package_id = input[0].package_id
    //  console.log("package_id -- ", package_id)

    const output = input.map(item => {
      const service = item.Service;

      const transformedServiceChargeBases = service.ServiceChargeBases.map(scBase => ({
        id: scBase.id,
        service_id: service.id,
        chargebasis_id: scBase.ChargeBasis.id,
        price_rate: scBase.price_rate,
        incremental_price: scBase.incremental_price,
        min_base_price: scBase.min_base_price,
        chargebasis_asc_order: scBase.chargebasis_asc_order,
        operator: scBase.operator,
        ChargeBasis: {
          ...scBase.ChargeBasis,
          BasisType: {
            ...scBase.ChargeBasis.BasisType
          }
        },
        ServiceChargeBasisValues: scBase.ServiceChargeBasisValues.map(val => ({
          ...val,
          ChargeType: { ...val.ChargeType }
        }))
      }));

      let price = item?.Package?.PackageServices?.find(ps => ps.service_id === service.id)?.price || 0;

      return {
        id: 18,
        agent_id: service.agent_id,
        package_id: item.package_id,
        service_id: item.service_id,
        //price: item.price,
        price: price,
        Service: {
          ...service,
          ServiceChargeBases: transformedServiceChargeBases
        }
      };
    });


    // console.log(" Update Package ", output);

    if (!["", null, undefined].includes(package_id)) {
      // console.log("ffff",res.packages)
      let packageDetails = res.packages.find((item) => item.id == package_id);
      if (packageDetails != undefined) {
        //  console.log("packageDetails",packageDetails)
        setMax_discount(parseFloat(packageDetails.max_discount));
      }

      setPackageID(package_id);
      setDefaultPrice_exist(packageDetails?.default_price || 0);
      setPackagesServiceData(output);
    }

    return package_id

  };

  const getQuoteCallFirstTime = async () => {
    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: 1, type: "onlyIdData" };
    await dispatch(getQuoteData(req)).unwrap()
      .then(async (res) => {
        console.log("res -- ggggggggg ", res)
        if (res.status) {
          if (!['', null, undefined].includes(res?.quote?.Agent?.ConfigSetting)) {
            setAgentConfigSetting(res?.quote?.Agent?.ConfigSetting);
          }

          if (res?.quote?.QuotePackageServices.length > 0) {
            let value = res.quote.quote_service_type;
            setServiceTypeForQuote(value);
            setAddedService([]);
            setPackageID(null);
            setPackagesServiceData([]);
            if (value == "1" || value == "2") {
              await getQuote(value)
            } else {
              setServiceTypeForQuote("");
              setIsSelfAssessmentChargeBasis(false)
              setQuoteData({
                quote: [],
                chargeBasisQuery: [],
                onOffServices: [],
                onGoingServices: [],
                packages: [],
              });
            }
          }
        }

      })
      .catch((err) => {
        console.log("err", err);
      });

  };

  const getQuote = async (ongoing_onoff) => {

    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: ongoing_onoff };
    await dispatch(getQuoteData(req)).unwrap()
      .then(async (res) => {

        if (res.status) {


          if (Number(ongoing_onoff) == 1) {
            setIsSelfAssessmentChargeBasis(res?.chargeBasisQuery?.some((item) => item.basistypes_id == 5))

            // Enter default values for charge basis
            const defaultValues = res?.chargeBasisQuery?.filter(item => [1, 2, 3, 4].includes(item.basistypes_id))?.map(item => {

              const isInput = [1, 2].includes(item.basistypes_id);
              const isSelect = [3, 4].includes(item.basistypes_id);
              return {
                chargebasis_id: item.id,
                chargetype_rule_id: isSelect ? item.ChargeTypes?.[0]?.id : null,
                inputValue: isInput ? 0 : null,
                pricing_queries: item?.pricing_queries,
                basistypes_id: item?.basistypes_id,
                ChargeTypes: item?.ChargeTypes,
              };
            });
            setQuoteEnterDefaultValue(defaultValues);


            let EnterDefault = []
            //  <------------Updated Quote Enter Default Value Set ///
            if (res.quote.QuoteEnterDefaultValues.length > 0) {
              EnterDefault = await UpdatedQuoteEnterDefualt(res.quote.QuoteEnterDefaultValues, defaultValues);
            }
            ////  -Updated Quote Enter Default Value Set----------> ///


            //  <------------Updated Quote UpdatedServiceOnly  Value Set ///
            let PACKAGE_ID = null
            if (res.quote.QuotePackageServices.length > 0) {
              await UpdatedServiceOnly(res.quote.QuotePackageServices)

              // Package services
              PACKAGE_ID = await UpdatedPackageService(res.quote.QuotePackageServices, res)
            }
            ////  -Updated Quote UpdatedServiceOnly Value Set----------> ///



            if (PACKAGE_ID != null) {
              let existpackageDetals = res.PackageDetails.QuotePackageServices.find((val) => val.Package != null)
              if (existpackageDetals != undefined) {
                setDiscount_exist(parseFloat(existpackageDetals.Package.default_discount || 0));
              }

            }



            quoteData?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))


            const defaultValues_selfassessment = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))?.map(item => {
              const isInput = item.basistypes_id === 1;
              const isSelfAsscessment = item.basistypes_id === 5;
              return {
                chargebases_id: item.id,
                name: item.name,
                basistypes_id: item.basistypes_id,
                individual: [
                  {
                    name: "Individual 1",
                    inputValue: isInput ? 0 : null,
                    radio_option: isSelfAsscessment ? "0" : "0",
                  }
                ]


              };
            });
            setQuoteIndividualSetValue(defaultValues_selfassessment);



            //  <------------Updated UpdateIndividualSetValue Value Set ///
            let EnterIndividualSetValue = []
            if (res.quote.QuoteIndividuals.length > 0) {
              const chargeBasisQuery = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))
              EnterIndividualSetValue = await UpdateIndividualSetValue(res.quote.QuoteIndividuals, chargeBasisQuery)
            }
            ////  -Updated UpdateIndividualSetValue Value Set----------> ///


            let EnterIndividualSetValueReq = EnterIndividualSetValue.length > 0 ? EnterIndividualSetValue : defaultValues_selfassessment;
            let EnterDefaultReq = EnterDefault.length > 0 ? EnterDefault : defaultValues;

            debouncedSearch({ quoteEnterDefaultValue: EnterDefaultReq, selfAssessmentCount: Number(res.quote.self_assessment_need_input), packageID: PACKAGE_ID, quoteIndividualSetValue: EnterIndividualSetValueReq, packages: res.packages });



            setQuoteData({
              quote: res.quote,
              chargeBasisQuery: res.chargeBasisQuery,
              services: res.services,
              packages: res.packages,
            });




          }
          else if (Number(ongoing_onoff) == 2) {
            setIsSelfAssessmentChargeBasis(res?.chargeBasisQuery?.some((item) => item.basistypes_id == 5))

            // Enter default values for charge basis
            const defaultValues = res?.chargeBasisQuery?.filter(item => [1, 2, 3, 4].includes(item.basistypes_id))?.map(item => {
              const isInput = [1, 2].includes(item.basistypes_id);
              const isSelect = [3, 4].includes(item.basistypes_id);
              return {
                chargebasis_id: item.id,
                chargetype_rule_id: isSelect ? item.ChargeTypes?.[0]?.id : null,
                inputValue: isInput ? 0 : null,
                pricing_queries: item?.pricing_queries,
                basistypes_id: item?.basistypes_id,
                ChargeTypes: item?.ChargeTypes,
              };
            });
            setQuoteEnterDefaultValue(defaultValues);

            //  <------------Updated Quote Enter Default Value Set ///
            if (res.quote.QuoteEnterDefaultValues.length > 0) {
              await UpdatedQuoteEnterDefualt(res.quote.QuoteEnterDefaultValues, defaultValues);
            }
            ////  -Updated Quote Enter Default Value Set----------> ///

            //  <------------Updated Quote UpdatedServiceOnly Value Set ///
            if (res.quote.QuotePackageServices.length > 0) {
              await UpdatedServiceOnly(res.quote.QuotePackageServices)
            }
            ////  -Updated Quote UpdatedServiceOnly Value Set----------> ///


            // 
            quoteData?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))


            const defaultValues_selfassessment = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))?.map(item => {
              const isInput = item.basistypes_id === 1;
              const isSelfAsscessment = item.basistypes_id === 5;
              return {
                chargebases_id: item.id,
                name: item.name,
                basistypes_id: item.basistypes_id,
                individual: [
                  {
                    name: "Individual 1",
                    inputValue: isInput ? 0 : null,
                    radio_option: isSelfAsscessment ? "0" : "0",
                  }
                ]

              };
            });
            setQuoteIndividualSetValue(defaultValues_selfassessment);



            //  <------------Updated UpdateIndividualSetValue Value Set ///
            if (res.quote.QuoteIndividuals.length > 0) {
              const chargeBasisQuery = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))
              await UpdateIndividualSetValue(res.quote.QuoteIndividuals, chargeBasisQuery)
            }
            ////  -Updated UpdateIndividualSetValue Value Set----------> ///


            setQuoteData({
              quote: res.quote,
              chargeBasisQuery: res.chargeBasisQuery,
              services: res.services,
              packages: [],
            });

          }


          // set Quote value exist
          if (res.quote.QuotePackageServices.length > 0) {
            //await EditFunctionRun(res);
            setNeedSelfAssessmentRadio(Number(res?.quote?.self_assessment_need_status) == 1 ? 1 : 0);
            setSelfAssessmentCount(Number(res?.quote?.self_assessment_need_input));
            setShowDiscount(res?.quote?.show_discount);
            setShowPrice(res?.quote?.show_price);
            setSelectedLabelComplexity(res?.quote?.complexity_label || 'Default');
            setSelectedLabelRisk(res?.quote?.risk_label || 'Default');
            setComplexityValue(res?.quote?.complexity_premium || 0);
            setRiskValue(res?.quote?.risk_premium || 0);
            setSliderValueComplexity([0, levels[res?.quote?.complexity_label || 'Default']]);
            setSliderValueRisk([0, levels[res?.quote?.risk_label || 'Default']]);
            if (Number(ongoing_onoff) == 1) {
              setDiscount(parseFloat(res?.quote?.discount_ongoing || 0));
              setPremium(parseFloat(res?.quote?.premium_ongoing || 0));

              setPaymentTerm(res?.quote?.payment_term_ongoing);
              setPaymentTypeOfModal(res?.quote?.payment_type_ongoing);
            } else if (Number(ongoing_onoff) == 2) {
              setDiscount(parseFloat(res?.quote?.discount_oneoff || 0));

              setPremium(parseFloat(res?.quote?.premium_oneoff || 0));
              setPaymentTerm(res?.quote?.payment_term_oneoff);
              setPaymentTypeOfModal(res?.quote?.payment_type_oneoff);
            }
          }

        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getQuoteReSelect = async (ongoing_onoff) => {
    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: ongoing_onoff };
    await dispatch(getQuoteData(req)).unwrap()
      .then(async (res) => {

        if (res.status) {


          if (Number(ongoing_onoff) == 1) {
            setIsSelfAssessmentChargeBasis(res?.chargeBasisQuery?.some((item) => item.basistypes_id == 5))

            // Enter default values for charge basis
            const defaultValues = res?.chargeBasisQuery?.filter(item => [1, 2, 3, 4].includes(item.basistypes_id))?.map(item => {
              const isInput = [1, 2].includes(item.basistypes_id);
              const isSelect = [3, 4].includes(item.basistypes_id);
              return {
                chargebasis_id: item.id,
                chargetype_rule_id: isSelect ? item.ChargeTypes?.[0]?.id : null,
                inputValue: isInput ? 0 : null,
                pricing_queries: item?.pricing_queries,
                basistypes_id: item?.basistypes_id,
                ChargeTypes: item?.ChargeTypes,
              };
            });
            setQuoteEnterDefaultValue(defaultValues);



            const defaultValues_selfassessment = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))?.map(item => {
              const isInput = item.basistypes_id === 1;
              const isSelfAsscessment = item.basistypes_id === 5;
              return {
                chargebases_id: item.id,
                name: item.name,
                basistypes_id: item.basistypes_id,
                individual: [
                  {
                    name: "Individual 1",
                    inputValue: isInput ? 0 : null,
                    radio_option: isSelfAsscessment ? "0" : "0",
                  }
                ]


              };
            });
            setQuoteIndividualSetValue(defaultValues_selfassessment);


            debouncedSearch({ quoteEnterDefaultValue: defaultValues, selfAssessmentCount: Number(res.quote.self_assessment_need_input), packageID: packageID, quoteIndividualSetValue: defaultValues_selfassessment, packages: res.packages });


            setQuoteData({
              quote: res.quote,
              chargeBasisQuery: res.chargeBasisQuery,
              services: res.services,
              packages: res.packages,
            });




          }
          else if (Number(ongoing_onoff) == 2) {
            setIsSelfAssessmentChargeBasis(res?.chargeBasisQuery?.some((item) => item.basistypes_id == 5))

            // Enter default values for charge basis
            const defaultValues = res?.chargeBasisQuery?.filter(item => [1, 2, 3, 4].includes(item.basistypes_id))?.map(item => {
              const isInput = [1, 2].includes(item.basistypes_id);
              const isSelect = [3, 4].includes(item.basistypes_id);
              return {
                chargebasis_id: item.id,
                chargetype_rule_id: isSelect ? item.ChargeTypes?.[0]?.id : null,
                inputValue: isInput ? 0 : null,
                pricing_queries: item?.pricing_queries,
                basistypes_id: item?.basistypes_id,
                ChargeTypes: item?.ChargeTypes,
              };
            });
            setQuoteEnterDefaultValue(defaultValues);



            const defaultValues_selfassessment = res?.chargeBasisQuery?.filter(item => item.basistypes_id == 5 || (item.basistypes_id == 1 && Number(item.self_assessment) == 1))?.map(item => {
              const isInput = item.basistypes_id === 1;
              const isSelfAsscessment = item.basistypes_id === 5;
              return {
                chargebases_id: item.id,
                name: item.name,
                basistypes_id: item.basistypes_id,
                individual: [
                  {
                    name: "Individual 1",
                    inputValue: isInput ? 0 : null,
                    radio_option: isSelfAsscessment ? "0" : "0",
                  }
                ]

              };
            });
            setQuoteIndividualSetValue(defaultValues_selfassessment);


            setQuoteData({
              quote: res.quote,
              chargeBasisQuery: res.chargeBasisQuery,
              services: res.services,
              packages: [],
            });

          }

        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleNeedSelfChange = (e) => {
    let { name } = e.target;
    if (name == "yes") {
      let checked = e.target.checked;
      if (checked == true) {
        if (selfAssessmentCount == 0 || selfAssessmentCount == "") {
          setSelfAssessmentCount(1);
        }
        setNeedSelfAssessmentRadio(1);
      }
    }
    else if (name == "no") {
      let checked = e.target.checked;
      if (checked == true) {

        if (Number(selfAssessmentCount) > 0) {
          setSelfAssessmentCount(selfAssessmentCount);
        } else {
          setSelfAssessmentCount(0);
        }

        setNeedSelfAssessmentRadio(0);

        let removeIdSelfAssessment = addedService?.filter(service => Number(service.incremental_rule) === 1).map(service => service.id);

        setAddedService((prevServices) =>
          prevServices.filter(service => service.incremental_rule !== "1")
        );

        setServiceData((prev) =>
          prev.filter(item => !removeIdSelfAssessment.includes(item.value))
        );


      }
    }
  };

  const searchApiQualifyPackage = async (text) => {


    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: 1, type: "searchPackageQualify", searchQuery: text };
    await dispatch(getQuoteData(req)).unwrap()
      .then(async (res) => {


        setQualifyPackages(res?.packages || []);
        if (text.packageID != null) {
          let packageDetails = [...text.packages, ...(quoteData.packages), ...(res?.packages)].find(
            (item) => item.id == Number(text.packageID)
          );
          //console.log("packageDetails Qualify ", packageDetails)
          if (packageDetails == undefined) {



            setPackageID(null);
            setPackagesServiceData([]);
            setDiscount(0);
            setPremium(0);
            setDiscount_exist(0);
            setStatus_discount('1');
            setMax_discount(0);
            setPaymentTerm("");
            setPaymentTypeOfModal("");
            // if (containsGoCardless == false) {
            //   setPaymentTerm("100_upfront");
            // } else {
            //   setPaymentTerm("monthly_dd");
            // }

          }

        }

      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // debounce wrap
  const debouncedSearch = useCallback(
    debounce((text) => {
      searchApiQualifyPackage(text);
    }, 500), // 500ms delay
    []
  );

  const inputChangeChargeBasisFun = async (e, item, index, type) => {

    let packages = quoteData.packages;
    let { name, value } = e.target;

    if (name == "needSelfAssessmentCount") {


      const isValid = /^[0-9]+$/.test(value);
      if (!isValid) {
        if (value == "") {
          debouncedSearch({ quoteEnterDefaultValue: quoteEnterDefaultValue, selfAssessmentCount: "", packageID: packageID, quoteIndividualSetValue: quoteIndividualSetValue });
          await stateManageQuoteIndividualSetValue(1, packages);
        }
        setSelfAssessmentCount("")
        return
      }
      if (value > 5) {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "You can only add 5 individuals",
          confirmButtonText: "ok"
        });
        setSelfAssessmentCount(5)
        await stateManageQuoteIndividualSetValue(5, packages);
        return
      }


      setSelfAssessmentCount(value);
      await stateManageQuoteIndividualSetValue(value, packages);

    }

    // 2 Handle chargeBasisQuery dynamic inputs (chargeBasisQuery_0, chargeBasisQuery_1, etc.)
    else if (name.startsWith("chargeBasisQuery_")) {

      const isValid = /^[0-9]+$/.test(value);
      if (isValid == false) {
        value = 0
      }

      const updatedCharges = [...quoteEnterDefaultValue];
      const existingIndex = updatedCharges.findIndex(val => val.chargebasis_id === item.chargebasis_id);

      if (existingIndex !== -1) {
        // Update existing object
        if (type === "input") {
          updatedCharges[existingIndex].inputValue = Number(value);
        } else if (type === "dropdown") {
          updatedCharges[existingIndex].chargetype_rule_id = Number(value);
        }
      }

      debouncedSearch({ quoteEnterDefaultValue: updatedCharges, selfAssessmentCount: selfAssessmentCount, packageID: packageID, quoteIndividualSetValue: quoteIndividualSetValue, packages: packages });

      setQuoteEnterDefaultValue(updatedCharges);
    }

    else if (type === 'radio' || type === 'input') {

      const isValid = /^[0-9]+$/.test(value);
      if (type === 'input' && isValid == false) {
        value = 0
      }

      const match = name.match(/name_(\d+)_ind_(\d+)/);
      if (match) {
        const qIndexFromName = Number(match[1]);
        const indIndexFromName = Number(match[2]);

        const updatedQuoteIndividualSetValue = [...quoteIndividualSetValue];

        // Ab yahan deep level pe update karna hai
        if (type === 'radio') {
          updatedQuoteIndividualSetValue[qIndexFromName].individual[indIndexFromName].radio_option =
            value === "on" || value === "1" ? "1" : "0";
        } else if (type === 'input') {
          updatedQuoteIndividualSetValue[qIndexFromName].individual[indIndexFromName].inputValue = Number(value);
        }

        debouncedSearch({ quoteEnterDefaultValue: quoteEnterDefaultValue, selfAssessmentCount: selfAssessmentCount, packageID: packageID, quoteIndividualSetValue: updatedQuoteIndividualSetValue, packages: packages });

        setQuoteIndividualSetValue(updatedQuoteIndividualSetValue);
      }
    }


  };

  const stateManageQuoteIndividualSetValue = (value, packages) => {
    // console.log("stateManageQuoteIndividualSetValue -- ", value)
    setQuoteIndividualSetValue(prevData =>
      prevData.map(item => {
        let updatedIndividual = [...item.individual];

        // If increased
        if (updatedIndividual.length < value) {
          const toAdd = value - updatedIndividual.length;
          for (let i = 0; i < toAdd; i++) {
            // console.log("item ", item)
            let input = item?.basistypes_id == 1 ? 0 : null;
            let radio = item?.basistypes_id == 5 ? "0" : "0";
            updatedIndividual.push({
              name: `Individual ${updatedIndividual.length + 1}`,
              inputValue: input,
              radio_option: radio,
            });
          }
        }
        // If decreased
        else if (updatedIndividual.length > value) {
          updatedIndividual = updatedIndividual.slice(0, value);
        }

        return {
          ...item,
          individual: updatedIndividual
        };
      })
    );
    const updatedData = quoteIndividualSetValue.map(item => {
      let updatedIndividual = [...item.individual];

      if (updatedIndividual.length < value) {
        const toAdd = value - updatedIndividual.length;
        for (let i = 0; i < toAdd; i++) {
          let input = item?.basistypes_id == 1 ? 0 : null;
          let radio = item?.basistypes_id == 5 ? "0" : "0";
          updatedIndividual.push({
            name: `Individual ${updatedIndividual.length + 1}`,
            inputValue: input,
            radio_option: radio,
          });
        }
      } else if (updatedIndividual.length > value) {
        updatedIndividual = updatedIndividual.slice(0, value);
      }

      return {
        ...item,
        individual: updatedIndividual
      };
    });
    //console.log("updatedData -- ", updatedData)
    debouncedSearch({ quoteEnterDefaultValue: quoteEnterDefaultValue, selfAssessmentCount: Number(value), packageID: packageID, quoteIndividualSetValue: updatedData, packages: packages });
  };
  // Added Select Services
  const handleAddService = (selectedOptions) => {
    const selectedIds = selectedOptions.map((option) => parseInt(option.value));
    setServiceData(selectedOptions);

    const filteredServices = quoteData.services.filter((service) =>
      selectedIds.includes(parseInt(service.id))
    );


    // const updatedServices = filteredServices.map((service) => {
    //   // Check if service was already added earlier
    //   const existing = addedService.find(s => s.id === service.id);
    //   if (existing) {
    //     return existing; 
    //   } else {
    //     const price = servicePriceCalculation(service);
    //     return {
    //       ...service,
    //       price: price
    //     };
    //   }
    // });

    const updatedServices = filteredServices
      .map((service) => {
        const existing = addedService.find(s => s.id === service.id);
        if (existing) {
          return existing;
        } else {
          const price = servicePriceCalculation(service);
          if (price === 'ChargeBasisNotExist') {
            return null;
          }
          return {
            ...service,
            price: price
          };
        }
      })
      .filter(Boolean);

    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

      const AllServicesWithoutPerHour = updatedServices.filter(service => {
        const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
        const matchingBasis = service.ServiceChargeBases.find(basis =>
          basis.chargebasis_id === defaultBasisId &&
          basis.ChargeBasis?.BasisType?.id === 2
        );
        return !matchingBasis;
      });

      if (Number(serviceTypeForQuote) === 1) {
        if (AllServicesWithoutPerHour.length === 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_single)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_single));
          }
        } else if (AllServicesWithoutPerHour.length > 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_multiple)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_multiple));
          }
        }
      } else if (Number(serviceTypeForQuote) === 2) {
        if (AllServicesWithoutPerHour.length === 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_oneoff_single)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_oneoff_single));
          }
        } else if (AllServicesWithoutPerHour.length > 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_oneoff_multiple)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_oneoff_multiple));
          }
        }
      }

    }

    setAddedService(updatedServices);
  };
  // Remove Service
  const handleDeleteService = async (index) => {
    const updatedServices = [...addedService];
    updatedServices.splice(index, 1); // Remove service at given index

    if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

      const AllServicesWithoutPerHour = updatedServices.filter(service => {
        const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
        const matchingBasis = service.ServiceChargeBases.find(basis =>
          basis.chargebasis_id === defaultBasisId &&
          basis.ChargeBasis?.BasisType?.id === 2
        );
        return !matchingBasis;
      });

      if (Number(serviceTypeForQuote) === 1) {
        if (AllServicesWithoutPerHour.length === 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_single)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_single));
          }
        } else if (AllServicesWithoutPerHour.length > 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_ongoing_multiple)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_ongoing_multiple));
          }
        }
      } else if (Number(serviceTypeForQuote) === 2) {
        if (AllServicesWithoutPerHour.length === 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_oneoff_single)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_oneoff_single));
          }
        } else if (AllServicesWithoutPerHour.length > 1) {
          if (parseFloat(discount) > parseFloat(agentConfigSetting?.discount_oneoff_multiple)) {
            setDiscount(parseFloat(agentConfigSetting?.discount_oneoff_multiple));
          }
        }
      }

    }

    setAddedService(updatedServices);
    setServiceData((prevState) => {
      const updatedServices = [...prevState];
      updatedServices.splice(index, 1); // Remove service at given index
      return updatedServices;
    });

  };
  // Handle Change Charge Basis
  const handleChangeChargeBasis = (e, item, index) => {
    let { name } = e.target;
    // console.log("name -- ", name)
    if (name == "default") {
      const defaultBasis = item.ServiceChargeBases.find(
        b => Number(b.ChargeBasis.id) === Number(e.target.value)
      );
      const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
      let price;
      if ([3, 4].includes(Number(basisTypeId))) {
        const inputValue = (() => {
          const matchedItem = quoteEnterDefaultValue.find(
            item => item.chargebasis_id === defaultBasis.ChargeBasis.id
          );
          if (!matchedItem) return null;
          const valueObj = defaultBasis.ServiceChargeBasisValues.find(
            v => v.chargetype_rule_id === matchedItem.chargetype_rule_id
          );
          return valueObj ? valueObj.value : null;
        })();

        if (inputValue != null) {
          price = parseFloat(inputValue);
        } else {
          price = '-';
        }
      }
      else if (Number(basisTypeId) === 2) {
        price = defaultBasis.price_rate;
      }
      else {
        const inputValue = quoteEnterDefaultValue.find(item => item.chargebasis_id === defaultBasis.ChargeBasis.id)?.inputValue;
        if (inputValue != null && defaultBasis.price_rate != null) {
          let calculatPrice = parseFloat(inputValue) * parseFloat(defaultBasis.price_rate);
          if (calculatPrice > 0) {
            if (calculatPrice < parseFloat(defaultBasis.min_base_price)) {
              price = defaultBasis.min_base_price;
            } else {
              price = calculatPrice;
            }
          } else {
            price = 0;
          }
        } else {
          price = '-';
        }

      }
      setAddedService((prevState) => {
        const updatedServices = [...prevState];
        updatedServices[index].setDefaultId = Number(e.target.value);
        updatedServices[index].price = price;
        updatedServices[index].sell_chargebasis_id = Number(e.target.value);

        price = servicePriceCalculation(updatedServices[index])
        updatedServices[index].price = price;

        return updatedServices;
      });
    }

    else if (name == "frequency") {

      setAddedService((prevState) => {
        const updatedServices = [...prevState];
        updatedServices[index].setDefaultId = Number(e.target.value);
        updatedServices[index].sell_chargebasis_id = Number(e.target.value);
        let price = servicePriceCalculation(updatedServices[index])
        updatedServices[index].price = price;
        return updatedServices;
      });

    }

  };

  function servicePriceCalculation(service) {

    //Case 1 Use Default Charge Basis Calculation
    if (service.default_chargebasis_id != null && Number(service.default_chargebasis_status) == 1) {
      //console.log("service -- KKK ", service.sell_chargebasis_id)
      let matchId = service.default_chargebasis_id
      if (!['', null, undefined].includes(service.setDefaultId)) {
        matchId = service.setDefaultId
      }

      if (service.sell_chargebasis_id != undefined) {
        matchId = service.sell_chargebasis_id
      }

      const defaultBasis = service.ServiceChargeBases.find(
        b => b.ChargeBasis.id === matchId
      );

      if (defaultBasis == undefined) {
        return 'ChargeBasisNotExist';
      }
      const basisTypeId = defaultBasis?.ChargeBasis?.BasisType?.id;
      if ([3, 4].includes(Number(basisTypeId))) {

        const inputValue = (() => {
          const matchedItem = quoteEnterDefaultValue.find(
            item => item.chargebasis_id === defaultBasis.ChargeBasis.id
          );

          if (!matchedItem) return null;
          const valueObj = defaultBasis.ServiceChargeBasisValues.find(
            v => v.chargetype_rule_id === matchedItem.chargetype_rule_id
          );
          return valueObj ? valueObj.value : null;

        })();

        if (inputValue != null) {
          return parseFloat(inputValue);
        } else {
          return '-';
        }
      }
      else if (Number(basisTypeId) === 2) {
        return defaultBasis.price_rate;
      }
      else {
        const inputValue = quoteEnterDefaultValue.find(item => item.chargebasis_id === defaultBasis.ChargeBasis.id)?.inputValue;

        let rate_cutoff = defaultBasis?.rate_cutoff || null;
        let add_on_price = defaultBasis?.add_on_price || null;

        let extraPrice = 0;

        if (rate_cutoff != null && inputValue > rate_cutoff) {
          let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
          extraPrice = intervals * add_on_price;
        }


        if (inputValue != null && defaultBasis.price_rate != null) {
          let calculatPrice = parseFloat(inputValue) * parseFloat(defaultBasis.price_rate);
          if (calculatPrice > 0) {
            if (calculatPrice < parseFloat(defaultBasis.min_base_price)) {
              if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
                return defaultBasis.min_base_price + extraPrice;
              } else {
                return defaultBasis.min_base_price;
              }

            } else {
              if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
                calculatPrice = parseFloat(rate_cutoff) * parseFloat(defaultBasis.price_rate);
                return calculatPrice + extraPrice;
              } else {
                return calculatPrice;
              }
            }
          } else {
            return 0;
          }
        } else {
          return '-';
        }

      }


    }

    // Case 2 Use Incremental Rule Calculation
    else if (Number(service.incremental_rule) === 1) {
      const filteredMap = {};
      // console.log("quoteIndividualSetValue -- ", quoteIndividualSetValue)
      service?.ServiceChargeBases?.forEach(base => {
        const match = quoteIndividualSetValue?.find(
          input => input.chargebases_id === base.ChargeBasis.id
        );

        if (!match) return;

        const individualArray = match?.individual || [];
        individualArray.forEach((ind, index) => {
          const inputVal = parseFloat(ind.inputValue);

          if (ind.radio_option === "1" || inputVal > 0) {
            const key = base.ChargeBasis.id;

            if (!filteredMap[key]) {
              filteredMap[key] = {
                id: base.id,
                service_id: base.service_id,
                chargebasis_id: base.chargebasis_id,
                price_rate: base.price_rate,
                incremental_price: base.incremental_price,
                min_base_price: base.min_base_price,
                chargebasis_asc_order: base.chargebasis_asc_order,
                operator: base.operator,
                ChargeBasis: base.ChargeBasis, // ✅ preserved
                ServiceChargeBasisValues: base.ServiceChargeBasisValues || [],
                selectedIndex: 0,
                individual: [],
                basisTypeId: match.basistypes_id
              };
            }

            filteredMap[key].individual.push({
              ...ind,
              inputValue: inputVal || null
            });
          }
        });
      });


      let filtered = Object.values(filteredMap);
      //console.log("filtered first --", filtered);

      filtered = filtered?.map(item => {
        const match = quoteIndividualSetValue?.find(ref => Number(ref.chargebases_id) === Number(item.chargebasis_id));

        return {
          ...item,
          individual: match ? match.individual : item.individual
        };
      });

      // console.log("filtered second --", filtered);


      // Step 1: Flatten all individuals and attach metadata into `allIndividuals`
      const allIndividuals = [];

      filtered.forEach(item => {
        const basisTypeId = item.ChargeBasis.BasisType.id;
        const isPerUnit = basisTypeId === 1;
        const isSelfAssessment = basisTypeId === 5;

        item.individual.forEach((ind, index) => {
          allIndividuals.push({
            ...ind,
            chargeBasisId: item.chargebasis_id,
            min_base_price: item.min_base_price,
            incremental_price: item.incremental_price,
            price_rate: item.price_rate,
            basisTypeId,
            indexInGroup: index,
            isPerUnit,
            isSelfAssessment,
            radio_option: ind.radio_option // Include radio_option for self-assessment check
          });
        });
      });


      // let total = 0;
      // allIndividuals.forEach(ind => {

      //   const selfAssessIndividuals = allIndividuals.filter(i => i.isSelfAssessment && i.name === ind.name && i.radio_option === "1");
      //   const type5Prices = selfAssessIndividuals.map(i => i.min_base_price || 0);
      //   const uniqueType5Prices = new Set(type5Prices);

      //   if (uniqueType5Prices.size === type5Prices.length) {


      //     const maxBase = Math.max(...type5Prices);
      //     const individual1 = allIndividuals.filter(ind1 => ind1.name === ind.name);

      //     let isOnlyOneWithBasisTypePerUnit = false
      //     if (individual1.length === 1 && individual1[0].basisTypeId === 1) {
      //       // Case 1: Sirf ek hi item hai and wo basisTypeId 1 ka hai
      //       isOnlyOneWithBasisTypePerUnit = parseFloat(individual1[0].inputValue) > 0;

      //     } else {
      //       // Case 2: Multiple items — check both conditions
      //       const hasBasisType1WithInput = individual1.some(
      //         ind => ind.basisTypeId === 1 && parseFloat(ind.inputValue) > 0
      //       );

      //       const allOthersAreBasisType5WithRadio0 = individual1
      //         .filter(ind => ind.basisTypeId !== 1)
      //         .every(ind => ind.basisTypeId === 5 && ind.radio_option === "0");

      //       isOnlyOneWithBasisTypePerUnit = hasBasisType1WithInput && allOthersAreBasisType5WithRadio0;
      //     }


      //     let sub = 0;
      //     if (ind.isSelfAssessment && ind.radio_option === "1") {

      //       if (ind.min_base_price === maxBase) {
      //         sub = ind.min_base_price || 0;
      //       } else {
      //         sub = ind.incremental_price || 0;
      //       }
      //     }



      //     if (ind.isPerUnit) {
      //       const val = parseFloat(ind.inputValue);
      //       if (val > 0) {
      //         const calc = val * ind.price_rate;

      //         sub = (isOnlyOneWithBasisTypePerUnit && calc < ind.min_base_price)
      //           ? ind.min_base_price
      //           : calc;
      //       }
      //     }
      //     total += sub;

      //   }

      //   else {
      //     // console.log("SCENARIO 2: Some base prices are duplicated");
      //     // SCENARIO 2: Some base prices are duplicated
      //     // Group individuals by base price
      //     const individual1 = allIndividuals.filter(ind1 => ind1.name === ind.name);


      //     let isOnlyOneWithBasisTypePerUnit = false
      //     if (individual1.length === 1 && individual1[0].basisTypeId === 1) {
      //       // Case 1: Sirf ek hi item hai and wo basisTypeId 1 ka hai
      //       isOnlyOneWithBasisTypePerUnit = parseFloat(individual1[0].inputValue) > 0;

      //     } else {
      //       // Case 2: Multiple items — check both conditions
      //       const hasBasisType1WithInput = individual1.some(
      //         ind => ind.basisTypeId === 1 && parseFloat(ind.inputValue) > 0
      //       );

      //       const allOthersAreBasisType5WithRadio0 = individual1
      //         .filter(ind => ind.basisTypeId !== 1)
      //         .every(ind => ind.basisTypeId === 5 && ind.radio_option === "0");

      //       isOnlyOneWithBasisTypePerUnit = hasBasisType1WithInput && allOthersAreBasisType5WithRadio0;
      //     }



      //     // console.log("isOnlyOneWithBasisTypePerUnit -- ", isOnlyOneWithBasisTypePerUnit)

      //     let sub = 0;
      //     const basePriceGroups = {};
      //     selfAssessIndividuals.forEach(saInd => {
      //       const base = saInd.min_base_price;
      //       if (!basePriceGroups[base]) basePriceGroups[base] = [];
      //       basePriceGroups[base].push(saInd);
      //     });

      //     const allBasePrices = Object.keys(basePriceGroups).map(Number);
      //     const maxBasePrice = Math.max(...allBasePrices);
      //     const maxBaseGroup = basePriceGroups[maxBasePrice];

      //     let baseEntry;
      //     if (maxBaseGroup.length === 1) {
      //       baseEntry = maxBaseGroup[0];
      //     } else {
      //       baseEntry = maxBaseGroup.reduce((lowest, item) =>
      //         (item.incremental_price || Infinity) < (lowest.incremental_price || Infinity)
      //           ? item
      //           : lowest
      //       );
      //     }

      //     const baseEntryId = baseEntry.chargeBasisId;

      //     if (ind.chargeBasisId === baseEntryId) {
      //       sub = ind.min_base_price || 0;
      //     } else {
      //       sub = ind.incremental_price || ind.min_base_price || 0;
      //     }

      //     if (ind.isPerUnit) {
      //       const val = parseFloat(ind.inputValue);
      //       if (val > 0) {
      //         const calc = val * ind.price_rate;
      //         sub = (isOnlyOneWithBasisTypePerUnit && calc < ind.min_base_price)
      //           ? ind.min_base_price
      //           : calc;
      //       }
      //     }

      //     total += sub;
      //   }

      // });
      // return total;


      let total = 0;
      const uniqueNames = [...new Set(allIndividuals.map(ind => ind.name))];
      uniqueNames.forEach(name => {
        const individuals = allIndividuals.filter(ind => ind.name === name);
        //console.log("individuals -- ", individuals);
        const selfAssessIndividuals = individuals.filter(i => i.isSelfAssessment && i.radio_option === "1" || parseFloat(i.inputValue) > 0);
        //const type5Prices = selfAssessIndividuals.map(i => i.min_base_price || 0);
        const prices = selfAssessIndividuals
          .filter(i => i.basisTypeId === 5 || i.basisTypeId === 1)
          .filter(i => i.basisTypeId === 5)
          .map(i => i.min_base_price || 0);

        const type5Prices = prices.length > 0
          ? prices
          : selfAssessIndividuals
            .filter(i => i.basisTypeId === 1)
            .map(i => i.min_base_price || 0);

        // console.log("type5Prices", type5Prices);

        const uniqueType5Prices = new Set(type5Prices);

        const isOnlyOneWithBasisTypePerUnit = (() => {
          if (individuals.length === 1 && individuals[0].basisTypeId === 1) {
            return parseFloat(individuals[0].inputValue) > 0;
          } else {
            const hasBasisType1WithInput = individuals.some(
              ind => ind.basisTypeId === 1 && parseFloat(ind.inputValue) > 0
            );
            const allOthersAreBasisType5WithRadio0 = individuals
              .filter(ind => ind.basisTypeId !== 1)
              .every(ind => ind.basisTypeId === 5 && ind.radio_option === "0");

            return hasBasisType1WithInput && allOthersAreBasisType5WithRadio0;
          }
        })();

        // const isOnlyOneWithBasisTypePerUnit = (() => {
        //   if (individuals.length === 1 && individuals[0].basisTypeId === 1) {
        //     return parseFloat(individuals[0].inputValue) > 0;
        //   } else {
        //     const hasBasisType1WithInput = individuals.some(
        //       ind => ind.basisTypeId === 1 && parseFloat(ind.inputValue) > 0
        //     );

        //     const allOthersAreBasisType5 = individuals
        //       .filter(ind => ind.basisTypeId !== 1)
        //       .every(ind => ind.basisTypeId === 5);

        //     return hasBasisType1WithInput && allOthersAreBasisType5;
        //   }
        // })();

        // console.log("isOnlyOneWithBasisTypePerUnit -- ", isOnlyOneWithBasisTypePerUnit);
        // console.log("selfAssessIndividuals -- ", selfAssessIndividuals);
        if (uniqueType5Prices.size === type5Prices.length) {
          //  console.log("SCENARIO 1: All base prices unique");
          // console.log("selfAssessIndividuals -- ", selfAssessIndividuals);
          // SCENARIO 1: All base prices unique
          // console.log("type5Prices", type5Prices);
          const maxBase = Math.max(...type5Prices);
          selfAssessIndividuals.forEach(ind => {
            let sub = 0;
            if (ind.min_base_price === maxBase) {
              sub = ind.min_base_price || 0;
            } else {
              sub = ind.incremental_price || 0;
            }
            // console.log(" sub -- 1", sub)
            if (ind.isPerUnit) {
              // console.log("ind.inputValue -- IFF ", ind.inputValue)
              const val = parseFloat(ind.inputValue);
              //   console.log("ind.inputValue -- IFF val ", val)
              if (val > 0) {
                const calc = val * ind.price_rate;
                sub = (isOnlyOneWithBasisTypePerUnit && calc < ind.min_base_price)
                  ? ind.min_base_price
                  : calc;
              }
            }
            // console.log(" sub -- 2", sub)
            total += sub;
          });

        } else {
          // console.log("SCENARIO 2: Some base prices are duplicated");
          // SCENARIO 2: Some base prices duplicated
          // const basePriceGroups = {};
          // selfAssessIndividuals.forEach(saInd => {
          //   const base = saInd.min_base_price;
          //   if (!basePriceGroups[base]) basePriceGroups[base] = [];
          //   basePriceGroups[base].push(saInd);
          // });
          const prices = selfAssessIndividuals
            .filter(i => i.basisTypeId === 5 || i.basisTypeId === 1) // सिर्फ 1 और 5
            .filter(i => i.basisTypeId === 5) // type 5 priority
            .map(i => i.min_base_price || 0);

          const selectedPrices = prices.length > 0
            ? prices
            : selfAssessIndividuals
              .filter(i => i.basisTypeId === 1)
              .map(i => i.min_base_price || 0);

          const basePriceGroups = {};
          selectedPrices.forEach(price => {
            if (!basePriceGroups[price]) {
              basePriceGroups[price] = [];
            }
            basePriceGroups[price] = selfAssessIndividuals.filter(i => (i.min_base_price || 0) === price);
          });

          const allBasePrices = Object.keys(basePriceGroups).map(Number);
          const maxBasePrice = Math.max(...allBasePrices);

          // console.log("maxBasePrice -- ", maxBasePrice);

          const maxBaseGroup = basePriceGroups[maxBasePrice];

          // console.log("maxBaseGroup -- ", maxBaseGroup);

          let baseEntry;
          if (maxBaseGroup.length === 1) {
            baseEntry = maxBaseGroup[0];
          } else {
            baseEntry = maxBaseGroup.reduce((lowest, item) =>
              (item.incremental_price || Infinity) < (lowest.incremental_price || Infinity)
                ? item
                : lowest
            );
          }

          const baseEntryId = baseEntry.chargeBasisId;

          selfAssessIndividuals.forEach(ind => {
            // console.log("ind --ELSE ", ind);
            let sub = 0;

            if (ind.chargeBasisId === baseEntryId) {
              sub = ind.min_base_price || 0;
            } else {
              sub = ind.incremental_price || ind.min_base_price || 0;
            }

            if (ind.isPerUnit) {
              // console.log("ind.inputValue -- EEE ", ind.inputValue)
              const val = parseFloat(ind.inputValue);
              if (val > 0) {
                const calc = val * ind.price_rate;
                sub = (isOnlyOneWithBasisTypePerUnit && calc < ind.min_base_price)
                  ? ind.min_base_price
                  : calc;
              }
            }

            total += sub;
          });
        }
      });

      return total;

    }

    // Case 3 Use Frequency Custom Rule Calculation
    else if (Number(service.custom_rule == 1) && Number(service.link_frequency_rule == 1)) {
      return CustomRuleCalculateTotalPrice(service?.ServiceChargeBases?.filter((item) => Number(item?.ChargeBasis?.BasisType?.id) !== 2));
    }

    // Case 4 Use Custom Rule Calculation
    else if (Number(service.custom_rule == 1)) {
      // Frequency Rule Calculation

      if (Number(service.frequency_status == 1)) {
        // console.log("service -- inside ", service)
        //console.log("service -- ", service)
        // const frequencyChargeBasisAll = service?.ServiceChargeBases?.filter(
        //   item =>
        //     (item.ChargeBasis.id) === service?.frequency_optional_chargebasis_id ||
        //     item?.ChargeBasis?.BasisType?.id === 4
        // );

        const frequencyChargeBasisAll = service?.ServiceChargeBases?.filter(item =>
          (
            item.ChargeBasis.id === (
              service?.sell_chargebasis_id !== undefined && service?.sell_chargebasis_id !== null
                ? service.sell_chargebasis_id
                : service?.frequency_optional_chargebasis_id
            )
          ) || item?.ChargeBasis?.BasisType?.id === 4
        );

        // console.log("frequencyChargeBasisAll -- ", frequencyChargeBasisAll)
        const singleFrequencyChargeBasis = frequencyChargeBasisAll?.find(item => item?.ChargeBasis?.BasisType?.id === 4);
        const otherFrequencyChargeBasis = frequencyChargeBasisAll?.find(item => item?.ChargeBasis?.BasisType?.id !== 4);

        let otherFrequencyChargeBasisPerHourBasisId = otherFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
        if (Number(otherFrequencyChargeBasisPerHourBasisId) === 2) {
          return otherFrequencyChargeBasis.price_rate;
        }

        const singleFrequencyChargeBasisPrice = FrequencyRulePriceSingleChareBasis(singleFrequencyChargeBasis);


        let extraPrice = 0;
        let otherFrequencyBasisTypeId = otherFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
        if (Number(otherFrequencyBasisTypeId) === 1) {
          const inputValue = quoteEnterDefaultValue.find(item => item.chargebasis_id === otherFrequencyChargeBasis.ChargeBasis.id)?.inputValue;
          // console.log("otherFrequencyChargeBasis  ", otherFrequencyChargeBasis)
          // console.log("otherFrequencyBasisTypeId  ", otherFrequencyBasisTypeId)
          // console.log("inputValue -- ppp  ", inputValue)

          let rate_cutoff = otherFrequencyChargeBasis?.rate_cutoff || null;
          let add_on_price = otherFrequencyChargeBasis?.add_on_price || null;

          if (rate_cutoff != null && inputValue > rate_cutoff) {
            let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
            extraPrice = intervals * add_on_price;
          }
        }


        const otherFrequencyChargeBasisPrice = FrequencyRulePriceSingleChareBasis(otherFrequencyChargeBasis);
        if (singleFrequencyChargeBasisPrice != null && otherFrequencyChargeBasisPrice != null) {
          const operator = singleFrequencyChargeBasis.operator;
          const left = parseFloat(otherFrequencyChargeBasisPrice);
          const right = parseFloat(singleFrequencyChargeBasisPrice);

          switch (operator) {
            case '+':
              return (left + right) + extraPrice;
            case '-':
              return (left - right) + extraPrice;
            case '*':
              return (left * right) + extraPrice;
            case '/':
              return right !== 0 ? (left / right) + extraPrice : 0;
            default:
              return 0;
          }
        }

      } else {
        return CustomRuleCalculateTotalPrice(service?.ServiceChargeBases?.filter((item) => Number(item?.ChargeBasis?.BasisType?.id) !== 2));
        //return CustomRuleCalculateTotalPrice(service.ServiceChargeBases);
      }
    }

  };
  //Frequency Custom Rule Calculation
  const FrequencyRulePriceSingleChareBasis = (singleFrequencyChargeBasis) => {
    const basisTypeId = singleFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
    let singleFrequencyChargeBasisPrice = 0;
    if ([3, 4].includes(Number(basisTypeId))) {
      const inputValue = (() => {
        const matchedItem = quoteEnterDefaultValue.find(
          item => item.chargebasis_id === singleFrequencyChargeBasis.ChargeBasis.id
        );
        if (!matchedItem) return null;
        const valueObj = singleFrequencyChargeBasis.ServiceChargeBasisValues.find(
          v => v.chargetype_rule_id === matchedItem.chargetype_rule_id
        );
        return valueObj ? valueObj.value : null;
      })();

      if (inputValue != null) {
        singleFrequencyChargeBasisPrice = parseFloat(inputValue);
      } else {
        singleFrequencyChargeBasisPrice = 0
      }
    } else {
      const inputValue = quoteEnterDefaultValue.find(item => item.chargebasis_id === singleFrequencyChargeBasis.ChargeBasis.id)?.inputValue;
      // console.log("singleFrequencyChargeBasis -- innnn ", singleFrequencyChargeBasis)
      // console.log("inputValue -- innnn ", inputValue)
      let rate_cutoff = singleFrequencyChargeBasis?.rate_cutoff || null;
      let add_on_price = singleFrequencyChargeBasis?.add_on_price || null;

      if (inputValue != null && singleFrequencyChargeBasis.price_rate != null) {
        if (parseInt(inputValue) > 0) {
          let calculatPrice = parseFloat(inputValue) * parseFloat(singleFrequencyChargeBasis.price_rate);
          if (calculatPrice < parseFloat(singleFrequencyChargeBasis.min_base_price)) {
            singleFrequencyChargeBasisPrice = singleFrequencyChargeBasis.min_base_price;
          } else {
            if (rate_cutoff != null && Number(inputValue) > parseFloat(rate_cutoff)) {
              calculatPrice = parseFloat(rate_cutoff) * parseFloat(singleFrequencyChargeBasis.price_rate);
              singleFrequencyChargeBasisPrice = calculatPrice;
            } else {
              singleFrequencyChargeBasisPrice = calculatPrice;
            }
          }
        } else {
          singleFrequencyChargeBasisPrice = 0
        }
      } else {
        singleFrequencyChargeBasisPrice = 0
      }
    }
    return singleFrequencyChargeBasisPrice
  };
  //Basic Custom Rule Calculation
  const CustomRuleCalculateTotalPrice = (serviceChargeBases) => {
    const sortedChargeBases = [...serviceChargeBases].sort(
      (a, b) => a.chargebasis_asc_order - b.chargebasis_asc_order
    );
    let total = null;
    let extraPrice = 0;
    sortedChargeBases.forEach((item, index) => {

      let otherFrequencyChargeBasis = item

      const price = FrequencyRulePriceSingleChareBasis(item);

      let otherFrequencyBasisTypeId = otherFrequencyChargeBasis?.ChargeBasis?.BasisType?.id;
      if (Number(otherFrequencyBasisTypeId) === 1) {
        const inputValue = quoteEnterDefaultValue.find(item1 => item1.chargebasis_id === otherFrequencyChargeBasis.ChargeBasis.id)?.inputValue;

        let rate_cutoff = otherFrequencyChargeBasis?.rate_cutoff || null;
        let add_on_price = otherFrequencyChargeBasis?.add_on_price || null;

        if (rate_cutoff != null && inputValue > rate_cutoff) {
          let intervals = Math.ceil((inputValue - rate_cutoff) / rate_cutoff);
          extraPrice += intervals * add_on_price;
        }
      }
      // console.log("price --  Custom Rule ", price)
      // console.log("extraPrice Custom Rule ", extraPrice)

      if (index === 0) {
        total = price;
      } else {
        const operator = item.operator;
        switch (operator) {
          case '+':
            total += price;
            break;
          case '-':
            total -= price;
            break;
          case '*':
            total *= price;
            break;
          case '/':
            total = price !== 0 ? total / price : total; // avoid divide by 0
            break;
          default:
            break;
        }
      }
    });
    return total !== null ? total + extraPrice : 0;
  };
  // Package Service Calculation process
  const handlePackageSelect = async (e) => {

    setServiceData([]);
    setAddedService([]);

    if (e.target.value != "" && e.target.value != "Select an action") {
      //let packageDetails = quoteData.packages.find((item) => item.id == e.target.value);
      let packageDetails = [...(quoteData.packages || []), ...(qualifyPackages || [])].find(
        (item) => item.id == e.target.value
      );
      setDiscount(parseFloat(packageDetails.default_discount));
      setDiscount_exist(parseFloat(packageDetails.default_discount));
      setDefaultPrice_exist(parseFloat(packageDetails.default_price));
      setMax_discount(parseFloat(packageDetails.max_discount));
      setPackageID(e.target.value);
      await getPackageServices(e.target.value);
    } else {
      setDiscount(0);
      setDiscount_exist(0);
      setMax_discount(0);
      setPackageID(null);
      setPackagesServiceData([]);
    }
  };

  const getPackageServices = async (packageID) => {
    const req = { package_id: Number(packageID), agent_id: agent_id };
    if (packageID != "") {
      await dispatch(getSinglePackage(req)).unwrap()
        .then(async (res) => {
          if (res.status) {

            // console.log("res?.services -- ", res?.services)

            setPackagesServiceData(res?.services)
          }
          else {
            setPackagesServiceData([]);
          }
        })
        .catch((err) => {
          setPackagesServiceData([]);
          console.log("err", err);
        });
    } else {
      setPackagesServiceData([]);
    }
  };

  const [errorDiscount, setErrorDiscount] = useState(false);
  const [packageDefaultDiscount, setPackageDefaultDiscount] = useState(0);

  const InputChangeDiscountPremium = (e) => {
    let { name, value } = e.target;

    if (value === '.') {
      value = "0.";
    }

    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      return
    }


    // max_discountAgent
    // console.log("packageID", packageID);
    if (packageID == null) {
      // console.log("if", packageID);

      // console.log("agentConfigSetting d -- ", agentConfigSetting)
      // console.log("serviceTypeForQuote d -- ", serviceTypeForQuote)
      // console.log("addedService d -- ", addedService)
      let max_discountAgentConfig = null
      if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {


        const AllServicesWithoutPerHour = addedService.filter(service => {
          const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
          const matchingBasis = service.ServiceChargeBases.find(basis =>
            basis.chargebasis_id === defaultBasisId &&
            basis.ChargeBasis?.BasisType?.id === 2
          );
          return !matchingBasis;
        });


        if (Number(serviceTypeForQuote) === 1) {
          if (AllServicesWithoutPerHour.length === 1) {
            max_discountAgentConfig = agentConfigSetting?.discount_ongoing_single;
          } else if (AllServicesWithoutPerHour.length > 1) {
            max_discountAgentConfig = agentConfigSetting?.discount_ongoing_multiple;
          }
        } else if (Number(serviceTypeForQuote) === 2) {
          if (AllServicesWithoutPerHour.length === 1) {
            max_discountAgentConfig = agentConfigSetting?.discount_oneoff_single;
          } else if (AllServicesWithoutPerHour.length > 1) {
            max_discountAgentConfig = agentConfigSetting?.discount_oneoff_multiple;
          }
        }

      }

      if (name == 'discount' && max_discountAgentConfig == null) {
        value = value == "" ? "" : value;
      }
      else if (name == 'discount' && value != "" && parseFloat(value || 0) > max_discountAgentConfig) {
        value = parseFloat(max_discountAgentConfig);
      }


      // if (name == 'discount' && max_discountAgent == null) {
      //   value = value == "" ? "" : parseFloat(value);
      // }
      // else if (name == 'discount' && value != "" && parseFloat(value || 0) > max_discountAgent) {
      //   value = parseFloat(max_discountAgent);
      // }

    } else {

      let packageDetails = quoteData?.packages?.find((item) => item.id == packageID);
      setPackageDefaultDiscount(parseFloat(packageDetails.default_discount));
      if (name == 'discount' && value != "" && parseFloat(value || 0) > max_discount) {
        value = parseFloat(max_discount);
      }

      if (name == 'discount' && value != "" && parseFloat(value || 0) < parseFloat(packageDetails.default_discount)) {
        setErrorDiscount(true);
      } else {
        setErrorDiscount(false);
      }

    }

    if ((name == 'premium') && parseFloat(value || 0) < 0) {
      value = 0;
    }

    if ((name == 'premium' || name == 'discount') && value != "" && parseFloat(value || 0) > 100) {
      value = 100;
    }



    if (name == 'discount') {
      setDiscount(value);
    } else if (name == 'premium') {
      setPremium(value);
    }

  };

  /////////////////////------ Start Calculate OnGoing Services-------/////////////////////////// 

  const PriceArrayServiceArray = addedService.filter(service => {
    const defaultBasisId = service.sell_chargebasis_id || service.default_chargebasis_id;
    const matchingBasis = service.ServiceChargeBases.find(basis =>
      basis.chargebasis_id === defaultBasisId &&
      basis.ChargeBasis?.BasisType?.id === 2
    );
    return !matchingBasis;
  });

  const PriceArray = packageID != null ? packagesServiceData : PriceArrayServiceArray

  // const totalCost = PriceArray.length
  //   ? PriceArray.reduce((acc, value) => acc + (value.price || 0), 0)
  //   : 0;
  const totalCost = PriceArray.length
    ? PriceArray.reduce((acc, value) => acc + ((value.price + (value.price * increasePremiumFinal / 100)) || 0), 0)
    : 0;

  // console.log("totalCost -- ", totalCost)

  function toTwoDecimalNum(num) {
    return Math.trunc(num * 100) / 100;
  }

  let totalCostWithDiscount = totalCost - (totalCost * ((discount || 0) / 100));

  // const decimalPart = totalCostWithDiscount % 1;
  // if (decimalPart > 0 && decimalPart < 0.07) {
  //   totalCostWithDiscount = Math.floor(totalCostWithDiscount);
  // }

  if (packageID != null && parseFloat(discount) === parseFloat(discount_exist) && parseFloat(increasePremiumFinal) === 0) {
    totalCostWithDiscount = defaultPrice_exist;
  }

  totalCostWithDiscount = toTwoDecimalNum(totalCostWithDiscount);

  // Calculate net VAT 20 Amount
  const netVAT20Amount = PriceArray.length
    ?
    packageID != null ?
      // Package Service
      PriceArray.filter((service) => service.Service.vat_exempt === "0").reduce((acc, service) => acc + ((service.price + (service.price * increasePremiumFinal / 100)) || 0), 0)

      :
      // Added Service l
      PriceArray.filter((service) => service.vat_exempt === "0").reduce((acc, service) => acc + ((service.price + (service.price * increasePremiumFinal / 100)) || 0), 0)
    : 0;

  let netVAT20 = netVAT20Amount - (netVAT20Amount * ((discount || 0) / 100));
  netVAT20 = toTwoDecimalNum(netVAT20);

  // const netNoVATAmount 
  const netNoVATAmount = PriceArray.length
    ?
    packageID != null ?
      PriceArray.filter((service) => service.Service.vat_exempt === "1").reduce((acc, service) => acc + ((service.price + (service.price * increasePremiumFinal / 100)) || 0), 0)
      :
      PriceArray.filter((service) => service.vat_exempt === "1").reduce((acc, service) => acc + ((service.price + (service.price * increasePremiumFinal / 100)) || 0), 0)
    : 0;
  // Apply discount on netNoVAT
  let netNoVAT = netNoVATAmount - (netNoVATAmount * ((discount || 0) / 100));
  netNoVAT = toTwoDecimalNum(netNoVAT);


  if (netNoVAT === 0 && packageID != null && parseFloat(discount) === parseFloat(discount_exist) && parseFloat(increasePremiumFinal) === 0) {
    netVAT20 = defaultPrice_exist;
  }

  if (netVAT20 === 0 && packageID != null && parseFloat(discount) === parseFloat(discount_exist) && parseFloat(increasePremiumFinal) === 0) {
    netNoVAT = defaultPrice_exist;
  }

  let vat = (netVAT20 * 20) / 100;
  vat = toTwoDecimalNum(vat);

  let totalIncludingVATAmount = netVAT20 + vat + netNoVAT;




  if (agentData && agentData?.vat_registered != undefined && agentData?.vat_registered == "NO") {
    totalIncludingVATAmount = totalCostWithDiscount;
    netVAT20 = 0;
    vat = 0;
    netNoVAT = 0;
  }


  //const totalIncludingVAT = totalIncludingVATAmount + (totalIncludingVATAmount * ((increasePremiumFinal || 0) / 100))
  const totalIncludingVAT = totalIncludingVATAmount

  let paymentDivisors = {
    monthly_dd: 12,
    quarterly_dd: 4,
    '100_upfront': 1,
    '50_upfront': 2,
    '100_post_completion': 1,
    manual_payment_monthly: 12,
    manual_payment_quarterly: 4,
  };

  let totalMonthlyCost = totalIncludingVAT / (paymentDivisors[paymentTerm] || 1);
  let adminCharge = 0;
  // Apply extra admin charge for manual payments

  if (agentConfigSetting && typeof agentConfigSetting === "object" && Object.keys(agentConfigSetting).length > 0) {

    if (Number(agentConfigSetting.admin_charge) === 1) {
      if (paymentTerm === "manual_payment_monthly") {
        adminCharge = Math.max((totalIncludingVAT * 5) / 100, 25);
        totalMonthlyCost += adminCharge;
      } else if (paymentTerm === "manual_payment_quarterly") {
        adminCharge = Math.max((totalIncludingVAT * 5) / 100, 50);
        totalMonthlyCost += adminCharge;
      }
    }
  }

  /////////////////////------ End Calculate OnGoing Services-------///////////////////////////


  const paymentTermModal = (e) => {
    let { name, value } = e.target;

    if (['100_upfront', '50_upfront', '100_post_completion', 'manual_payment_monthly', 'manual_payment_quarterly'].includes(value)) {
      if (paymentTermTypeGetAgent.length > 0) {
        setPaymentTypeOfModal(paymentTermTypeGetAgent[0].value);
      }
      setShowModalPaymentTerm(true);
    }
    else if (['monthly_dd', 'quarterly_dd'].includes(value)) {
      setPaymentTypeOfModal("GoCardless");
    }
    else if (value == "") {
      setShowModalPaymentTerm(false);
      setPaymentTypeOfModal("");
    }
  };

  const handleSubmit = async () => {

    if (serviceTypeForQuote == "") {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please select service type",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    if (Number(serviceTypeForQuote) == 1) {
      if (addedService.length == 0 && packageID == null) {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please select at least one service or package",
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
    }

    else if (Number(serviceTypeForQuote) == 2 && addedService.length == 0) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please select at least one service",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    if (errorDiscount == true) {
      return;
    }


    else if (paymentTypeOfModal == "" && paymentTerm == "") {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please select payment term",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }


    const updatedPackageServices = packagesServiceData && packagesServiceData.map((service) => {
      //const basePrice = service?.price || 0;

      const basePrice = (service?.price + (service?.price * increasePremiumFinal / 100))

      const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      const matchingBasis = service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );

      let price_afterpremimum = basePrice + (basePrice * ((premium || 0) / 100));

      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));

      let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100));

      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.Service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }

      if (matchingBasis != undefined) {
        basePriceWithDiscount = basePrice
      }


      return {
        ...service,
        price: basePrice,
        service_id: service.Service.id,
        package_id: packageID != null ? packageID : null,
        mode: "ongoing",
        package_flag: "1",
        premium_applied: premium || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discount || 0,
        price_afterdiscount: basePriceWithDiscount,
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        service_type: "1",
        sell_chargebasis_id: null
      };
    });

    const updatedServices = addedService && addedService.map((service) => {
      //const basePrice = service.price || 0;
      let basePrice = (service.price + (service.price * increasePremiumFinal / 100))

      const defaultBasisId = service?.sell_chargebasis_id || service?.default_chargebasis_id;
      const matchingBasis = service?.ServiceChargeBases?.find(basis =>
        basis?.chargebasis_id === defaultBasisId &&
        basis?.ChargeBasis?.BasisType?.id === 2
      );

      if (matchingBasis != undefined) {
        basePrice = service?.price || 0;
      }

      let price_afterpremimum = basePrice + (basePrice * ((premium || 0) / 100));

      // let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100)) + (basePrice * ((premium || 0) / 100));
      let basePriceWithDiscount = basePrice - (basePrice * ((discount || 0) / 100));


      let vat_applied = "0";
      let price_aftervat = "0";
      if (service.vat_exempt === "0") {
        vat_applied = "20";
        price_aftervat = basePriceWithDiscount + ((basePriceWithDiscount * 20) / 100);
      }

      if (matchingBasis != undefined) {
        basePriceWithDiscount = basePrice
      }

      return {
        ...service,
        price: basePrice,
        package_id: null,
        service_id: service.id,
        mode: Number(serviceTypeForQuote) == 1 ? "ongoing" : "one-off",
        package_flag: "1",
        premium_applied: premium || 0,
        price_afterpremimum: price_afterpremimum,
        discount_rate: discount || 0,
        price_afterdiscount: basePriceWithDiscount,
        status_discount: "1",
        vat_applied: vat_applied,
        price_aftervat: price_aftervat,
        service_type: Number(serviceTypeForQuote) == 1 ? "1" : "0",
        sell_chargebasis_id: service.sell_chargebasis_id == undefined ? service.default_chargebasis_id : service.sell_chargebasis_id,
      };
    });

    let finalquotepackageservices = [...updatedPackageServices, ...updatedServices];




    //     For Ongoing Services:

    // Monthly DD map with Monthly
    // Quarterly DD map with Quarterly
    // 100 % upfront map with Yearly
    // 50 % Upfront map with Yearly
    // 100 % Post Completion map with Yearly
    // Manual payment Monthly map with Monthly
    // Manual Payment Quarterly map with Quarterly

    // For One-Off Services:

    // Monthly DD don't map
    // Quarterly DD don't map
    // 100 % upfront map with PAYG / Adhoc
    // 50 % Upfront map with PAYG / Adhoc
    // 100 % Post Completion map with PAYG / Adhoc - Yearly

    // Yearly
    // Monthly
    // Quarterly

    // Payment Frequency
    const paymentDivisorsFreguencyOngoing = {
      monthly_dd: 'Monthly',
      quarterly_dd: 'Quarterly',
      '100_upfront': 'Yearly',
      '50_upfront': 'Yearly',
      '100_post_completion': 'Yearly',
      manual_payment_monthly: "Monthly",
      manual_payment_quarterly: 'Quarterly',
    };
    let payment_frequency = (paymentDivisorsFreguencyOngoing[paymentTerm])



    // Payment Type
    // const paymentDivisorsTypeOngoing = {
    //   monthly_dd: 'GoCardless',
    //   quarterly_dd: 'GoCardless',
    //   '100_upfront': 'stripe',
    //   '50_upfront': 'stripe',
    //   '100_post_completion': 'stripe',
    //   manual_payment_monthly: "manual_payment",
    //   manual_payment_quarterly: 'manual_payment',
    // };
    // let payment_type = (paymentDivisorsTypeOngoing[paymentTerm])


    // console.log("finalquotepackageservices -- ", finalquotepackageservices)



    const req = {
      quotepackageservices: finalquotepackageservices,
      id: Number(QuoteId),
      step: 2,
      packageID: packageID,
      agent_id: agent_id,
      quoteEnterDefaultValue: quoteEnterDefaultValue.filter((item) => item.basistypes_id != 2),
      quoteIndividualSetValue: Number(needSelfAssessmentRadio) > 0 ? quoteIndividualSetValue : [],
      individuals: Number(needSelfAssessmentRadio) > 0 ? individuals : [],


      // Ongoing Services
      discount_ongoing: Number(serviceTypeForQuote) == 1 ? discount || 0 : null,
      premium_ongoing: Number(serviceTypeForQuote) == 1 ? premium || 0 : null,
      status_discount_ongoing: "1",
      payment_term_ongoing: Number(serviceTypeForQuote) == 1 ? paymentTerm : null,
      total_including_ongoing: Number(serviceTypeForQuote) == 1 ? totalIncludingVAT : null,
      total_monthly_ongoing: Number(serviceTypeForQuote) == 1 ? totalMonthlyCost : null,
      payment_type_ongoing: Number(serviceTypeForQuote) == 1 ? paymentTypeOfModal : null,
      payment_frequency_ongoing: Number(serviceTypeForQuote) == 1 ? payment_frequency : null,
      net20vat_ongoing: Number(serviceTypeForQuote) == 1 ? netVAT20 : null,
      vat_ongoing: Number(serviceTypeForQuote) == 1 ? vat : null,
      netnovat_ongoing: Number(serviceTypeForQuote) == 1 ? netNoVAT : null,
      admin_charge_ongoing: adminCharge,

      // One-Off Services
      discount_oneoff: Number(serviceTypeForQuote) == 2 ? discount || 0 : null,
      premium_oneoff: Number(serviceTypeForQuote) == 2 ? premium || 0 : null,
      payment_term_oneoff: Number(serviceTypeForQuote) == 2 ? paymentTerm : null,
      total_including_oneoff: Number(serviceTypeForQuote) == 2 ? totalIncludingVAT : null,
      total_monthly_oneoff: Number(serviceTypeForQuote) == 2 ? totalMonthlyCost : null,
      payment_type_oneoff: Number(serviceTypeForQuote) == 2 ? paymentTypeOfModal : null,
      payment_frequency_oneoff: Number(serviceTypeForQuote) == 2 ? payment_frequency : null,
      net20vat_oneoff: Number(serviceTypeForQuote) == 2 ? netVAT20 : null,
      vat_oneoff: Number(serviceTypeForQuote) == 2 ? vat : null,
      netnovat_oneoff: Number(serviceTypeForQuote) == 2 ? netNoVAT : null,


      // selectedService: selectedService,
      recurring: Number(serviceTypeForQuote) == 1 ? "1" : "0",
      one_off: Number(serviceTypeForQuote) == 2 ? "1" : "0",

      // extra Input
      show_discount: showDiscount,
      show_price: showPrice,
      self_assessment_need_status: needSelfAssessmentRadio.toString(),
      self_assessment_need_input: selfAssessmentCount == "" ? 0 : selfAssessmentCount,
      quote_service_type: serviceTypeForQuote,

      // Comlexity and Risk
      complexity_label: selectedLabelComplexity,
      complexity_premium: complexityValue,
      risk_label: selectedLabelRisk,
      risk_premium: riskValue,

      backupQuoteId: backupQuoteId
    }

    // console.log("req -- ", req)

    sessionStorage.setItem("quote_id", backupQuoteId);

    await dispatch(createQuote(req)).unwrap()
      .then((res) => {
        if (res.status) {
          let stepStatus = false;
          // if (updatedPackageServices.length > 0) {
          //   stepStatus = true;
          // }
          if (Number(res.quoteid) > 0) {
            sessionStorage.setItem("quote_id", res.quoteid);
            nextStep(stepStatus, { quoteid: res.quoteid })
          }
          // nextStep(stepStatus);
        }
        else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }).catch((err) => {
        console.log("err", err);
      })
  };


  let countChargeBsasis = 0;

  return (
    <div className="">

      <div className="row mb-4">
        <div className="col">
          <h4 className="page-title" >
            <i className='bx bx-arrow-back text-pink pe-1' onClick={prevStep} ></i>
            New Quote
            <span>


            </span>
          </h4>
        </div>
      </div>
      <div className="card p-4">
        <div className="row align-items-center ">
          <div className="col-md-6">
            <label className="col-form-label">
              Select Service type for Quote
            </label>
          </div>
          <div className="col-md-6">
            <select
              className="form-select"
              value={serviceTypeForQuote}
              onChange={(e) => setServiceTypeForQuoteChangeFun(e)}
            >
              <option value="">Select Service Type</option>
              <option value="1">Ongoing Services</option>
              <option value="2">One-Off Services</option>
            </select>
          </div>
        </div>


        {
          // Charge Basis Query --->
          quoteData?.chargeBasisQuery?.length > 0 ?
            <>
              <div className="gray-card mt-2">
                <div className="card-body">

                  <div className="row">
                    {
                      quoteEnterDefaultValue?.map((item, index) => {
                        const showInput = [1].includes(item.basistypes_id);
                        const showSelect = [3, 4].includes(item.basistypes_id);
                        if (!showInput && !showSelect) return null;
                        countChargeBsasis++
                        return (
                          <div className="col-md-6 pe-lg-5" key={index}>
                            <label className="col-form-label">
                              {countChargeBsasis}. {item.pricing_queries}
                            </label>

                            {
                              showSelect ? (
                                <select className="form-select"
                                  name={`chargeBasisQuery_${index}`}
                                  value={quoteEnterDefaultValue?.[index]?.chargetype_rule_id}
                                  onChange={(e) => inputChangeChargeBasisFun(e, item, index, 'dropdown')}
                                >
                                  {
                                    item?.ChargeTypes?.map((option, index1) => {
                                      return (
                                        <option key={index1} value={option.id}>
                                          {option.name}
                                        </option>
                                      );
                                    })
                                  }
                                </select>
                              )
                                :
                                showInput ?
                                  (
                                    <input type="text"
                                      className="form-control"
                                      name={`chargeBasisQuery_${index}`}
                                      value={quoteEnterDefaultValue?.[index]?.inputValue}
                                      onChange={(e) => inputChangeChargeBasisFun(e, item, index, 'input')}
                                    />
                                  )
                                  :
                                  ""
                            }
                          </div>
                        );
                      })
                    }

                  </div>

                  {
                    isSelfAssessmentChargeBasis ?
                      <div className="row mt-3 align-items-center">
                        <div className="col-md-6  ps-lg-3">
                          <div className="d-flex">
                            <label className="col-form-label c pt-0">
                              {countChargeBsasis + 1}. Do you need Self-Assessments?
                            </label>
                            <div className="ms-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="yes"
                                  id="gridRadios1"
                                  checked={needSelfAssessmentRadio === 1}
                                  onChange={(e) => handleNeedSelfChange(e)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="gridRadios1"
                                >
                                  Yes
                                </label>
                              </div>
                            </div>
                            <div className="ms-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="no"
                                  id="gridRadios1"
                                  checked={needSelfAssessmentRadio === 0}
                                  onChange={(e) => handleNeedSelfChange(e)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="gridRadios1"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ""
                  }
                </div>

                {
                  needSelfAssessmentRadio === 1 ?
                    <div className="table-responsive px-4">
                      <div className="col-md-6 pe-lg-5 mb-3">
                        <label className="col-form-label">
                          How many self assessments do you need?
                        </label>
                        <input type="text"
                          className="form-control"
                          name="needSelfAssessmentCount"
                          value={selfAssessmentCount}
                          onChange={(e) => inputChangeChargeBasisFun(e)}
                          placeholder="Enter number of self assessments"
                        />
                      </div>
                      <table className="table border">
                        <thead>
                          <tr>
                            <td
                              style={{
                                background: "#F5F5F5",
                                color: "#4E4E4E",
                                fontSize: "14px",
                              }}
                            >
                              Queries
                            </td>
                            {individuals.map((name, idx) => (
                              <td
                                width={"300px"}
                                key={idx}
                                style={{
                                  background: "#F5F5F5",
                                  color: "#4E4E4E",
                                  fontSize: "14px",

                                }}
                              >
                                {name}
                              </td>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {quoteIndividualSetValue?.map((q, qIndex) => (
                            <tr key={qIndex}>
                              <td className="fs-14">
                                <div style={{ width: '300px' }}>{q.name}</div></td>
                              {selfAssessmentCount != '' && q?.individual?.map((ind_item, indIndex) => (
                                <td className="fs-14" key={indIndex}>
                                  <div style={{ width: '150px', padding: '0px 15px 0 0' }}>
                                    {Number(q.basistypes_id === 5) ? (
                                      <div className="d-flex">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name={`name_${qIndex}_ind_${indIndex}`}
                                            id={`yes_q${qIndex}_i${indIndex}`}
                                            checked={ind_item.radio_option === "1"}
                                            onChange={(e) => inputChangeChargeBasisFun(e, q, qIndex, 'radio')}
                                          />
                                          <label className="form-check-label" htmlFor={`yes_q${qIndex}_i${indIndex}`}>
                                            Yes
                                          </label>
                                        </div>
                                        <div className="form-check ms-3">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name={`name_${qIndex}_ind_${indIndex}`}
                                            id={`no_q${qIndex}_i${indIndex}`}
                                            value="no"
                                            checked={ind_item.radio_option === "0"}
                                            onChange={(e) => inputChangeChargeBasisFun(e, q, qIndex, 'radio')}
                                          />
                                          <label className="form-check-label" htmlFor={`no_q${qIndex}_i${indIndex}`}>
                                            No
                                          </label>
                                        </div>
                                      </div>
                                    ) : (
                                      <input type="text"
                                        className="form-control"
                                        name={`name_${qIndex}_ind_${indIndex}`}
                                        id={`input_q${qIndex}_i${indIndex}`}
                                        value={ind_item.inputValue}
                                        onChange={(e) => inputChangeChargeBasisFun(e, q, qIndex, 'input')}

                                      />
                                    )}
                                  </div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    : ""
                }


              </div>
            </>
            : ""
          // <------ Charge Basis Query
        }




        {
          // Service Ongoing And One-Off Selection --->
          serviceTypeForQuote != "" ?
            <div className="card mt-4 shadow-none">
              <div className="card-body">
                <div className="row  align-items-center">

                  {
                    // Service Ongoing Package Selection --->
                    serviceTypeForQuote == "1" ?
                      <div className="col-md-6 pe-lg-5">
                        <div className="d-flex">
                          <label className="col-form-label w-50">Package Type</label>
                          {/* <select className="form-select">
                            <option value="">Select package</option>
                            <option value="1">package 1</option>
                            <option value="2">package 2</option>
                          </select> */}
                          <select className="form-select"
                            onChange={handlePackageSelect} value={packageID}
                          >
                            <option value="">Select package</option>
                            {/* {quoteData?.packages?.filter((item) => item?.status == "1").map((item, index) => (
                              <option key={index} value={item?.id}>
                                {item?.name}
                              </option>
                            ))} */}
                            {[...(quoteData?.packages || []), ...(qualifyPackages || [])]
                              .filter((item) => item?.status == "1")
                              .map((item, index) => (
                                <option key={index} value={item?.id}>
                                  {item?.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      :
                      <div className="col-md-6 pe-lg-5">
                        <div className="d-flex">

                        </div>
                      </div>
                    // <------ Service Ongoing Package Selection
                  }

                  { /* Search Service Ongoing And One-Off Selection ---> */}
                  <div className="col-md-6  ps-lg-5">
                    <div className="d-flex">
                      <div className="w-100">

                        <Select
                          options={quoteData.services
                            ?.filter((data) => {
                              if (needSelfAssessmentRadio === 1) {
                                return true;
                              } else {
                                return data.incremental_rule !== "1";
                              }
                            })
                            .map((data) => ({
                              label: data.name,
                              value: data.id
                            }))}
                          isMulti
                          className="w-100 z-index-999"
                          name="services"
                          closeMenuOnSelect={false}
                          placeholder="Select Services"
                          controlShouldRenderValue={false}
                          value={serviceData}
                          onChange={handleAddService}
                          isDisabled={packageID != null ? true : false}
                        />

                      </div>
                    </div>
                  </div>
                </div>


                { /* <------ Search Service Ongoing And One-Off Selection*/}






                {/* Show Discount And Show Price Button ---------> */}
                <div className="row  mt-3">
                  <div className="col-md-6 pe-lg-5">

                    <div className="row align-items-start mb-4 mt-3">
                      <div className="col-md-4">  <label className="col-form-label mb-0 py-0 me-2">  Complexity: </label></div>
                      <div className="col-md-8"
                        onClick={(e) => handleSliderComplexityClick(e)}
                        style={{ cursor: 'pointer' }}
                      >
                        <RangeSlider
                          className="single-thumb"
                          // defaultValue={[0, 50]}
                          value={sliderValueComplexity}
                          thumbsDisabled={[true, false]}
                          rangeSlideDisabled={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                          {Object.keys(levels).map((label, i) => (

                            <label
                              key={i}
                              className={`col-form-label pt-0 ${selectedLabelComplexity === label ? "fw-bold text-pink" : ''} ${i > 0 ? 'ms-3' : ''}`}
                              onClick={() => handleLabelComplexityClick(label)}
                              style={{
                                cursor: 'pointer',
                                color: selectedLabelComplexity === label ? '#ff00aa' : '#000000',
                              }}
                            >
                              {label}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>


                    <div className="d-flex">
                      <label className="col-form-label c pt-0">
                        Show Discount
                      </label>
                      <div className="ms-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gridRadios"
                            id="gridRadios1"
                            defaultValue="option1"
                            checked={showDiscount == "1"}
                            onChange={(e) => setShowDiscount("1")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gridRadios1"
                          >
                            Yes
                          </label>
                        </div>
                      </div>
                      <div className="ms-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gridRadios"
                            id="gridRadios1"
                            defaultValue="option1"
                            checked={showDiscount == "0"}
                            onChange={(e) => setShowDiscount("0")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gridRadios1"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6  ps-lg-5">

                    {/* <div className="row mt-3 mb-4">
                      <div className="col-md-4">  <label className="col-form-label mb-0 py-0 me-2">  Risk: </label></div>
                      <div className="col-md-8"><RangeSlider
                        className="single-thumb"
                        defaultValue={[0, 50]}
                        thumbsDisabled={[true, false]}
                        rangeSlideDisabled={true}
                      />
                        <div className="d-flex justify-content-between mt-2">
                          <label className="col-form-label  pt-0">
                            Defalult</label>
                          <label className="col-form-label  pt-0 ms-3">
                            Low  </label>
                          <label className="col-form-label  pt-0 ms-3">
                            Medium
                          </label>
                          <label className="col-form-label  pt-0 ms-3">
                            High
                          </label>
                        </div></div>

                    </div> */}

                    <div className="row align-items-start mb-4 mt-3">
                      <div className="col-md-4">  <label className="col-form-label mb-0 py-0 me-2">  Risk: </label></div>
                      <div className="col-md-8"
                        onClick={(e) => handleSliderRiskClick(e)}
                        style={{ cursor: 'pointer' }}
                      >
                        <RangeSlider
                          className="single-thumb"
                          // defaultValue={[0, 50]}
                          value={sliderValueRisk}
                          thumbsDisabled={[true, false]}
                          rangeSlideDisabled={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                          {Object.keys(levels).map((label, i) => (

                            <label
                              key={i}
                              className={`col-form-label pt-0 ${selectedLabelRisk === label ? "fw-bold text-pink" : ''} ${i > 0 ? 'ms-3' : ''}`}
                              onClick={() => handleLabelRiskClick(label)}
                              style={{
                                cursor: 'pointer',
                                color: selectedLabelRisk === label ? '#ff00aa' : '#000000',
                              }}
                            >
                              {label}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>



                    <div className="d-flex">
                      <label className="col-form-label c pt-0">Show price breakdown</label>
                      <div className="ms-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gridRadios1"
                            id="gridRadios11"
                            defaultValue="option1"
                            checked={showPrice === "1"}
                            onChange={(e) => setShowPrice("1")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gridRadios11"
                          >
                            Yes
                          </label>
                        </div>
                      </div>
                      <div className="ms-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gridRadios1"
                            id="gridRadios11"
                            defaultValue="option1"
                            checked={showPrice === "0"}
                            onChange={(e) => setShowPrice("0")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gridRadios11"
                          >
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <-------  Show Discount And Show Price Button*/}

                <div className="table-resposnsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th colSpan="4" className="bg-pink text-center text-white" style={{ fontSize: '20px' }}>
                          Quote for {serviceTypeForQuote == "1" ? 'Ongoing' : "One-Off"} Services
                        </th>
                      </tr>
                      <tr>
                        <td style={{ background: "#F5F5F5", color: "#4E4E4E", fontSize: "14px" }}>
                          Service
                        </td>
                        <td style={{ background: "#F5F5F5", color: "#4E4E4E", fontSize: "14px" }}>
                          Charge basis
                        </td>
                        <td style={{ background: "#F5F5F5", color: "#4E4E4E", fontSize: "14px" }}>
                          Price
                        </td>
                        {
                          packageID != null ? "" :
                            <td style={{ background: "#F5F5F5", color: "#4E4E4E", fontSize: "14px" }}
                            >Action</td>

                        }

                      </tr>
                    </thead>
                    <tbody>
                      {
                        packageID != null ?
                          packagesServiceData?.map((item, index) => (

                            <tr key={index}>
                              <td className="fs-14">{item.Service.name}</td>
                              <td className="fs-14 text-center">
                                {item.Service.default_chargebasis_status === "1" && item.Service.default_chargebasis_id ? (

                                  <div className="fs-8">
                                    {item.Service.ServiceChargeBases.map((chargeBase) => {
                                      if (chargeBase.ChargeBasis.id === item.Service.default_chargebasis_id) {
                                        return (
                                          <div key={chargeBase.id}>
                                            {chargeBase.ChargeBasis.name}
                                          </div>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="fs-14">
                                {/* {item.price} */}
                                {
                                  (item.price + (item.price * increasePremiumFinal / 100)).toFixed(2)
                                }
                              </td>



                            </tr>
                          ))
                          :
                          addedService.map((item, index) => (


                            <tr key={index}>
                              <td className="fs-14">{item.name}</td>
                              <td className="fs-14 text-center">
                                {item.default_chargebasis_status === "1" && item.default_chargebasis_id ? (
                                  <select
                                    name="default"
                                    className="form-select fs-8"
                                    onChange={(e) => handleChangeChargeBasis(e, item, index)}
                                  >
                                    {item.ServiceChargeBases.map((chargeBase) => (
                                      <option
                                        key={chargeBase.id}
                                        value={chargeBase.ChargeBasis.id}
                                        selected={
                                          item.sell_chargebasis_id != undefined ? item.sell_chargebasis_id === chargeBase.ChargeBasis.id :
                                            chargeBase.ChargeBasis.id === item.default_chargebasis_id
                                        }
                                      >
                                        {chargeBase.ChargeBasis.name}
                                      </option>
                                    ))}
                                  </select>
                                ) :



                                  Number(item.frequency_status) === 1 && Number(item.link_frequency_rule) === 1 ? (

                                    '-'

                                  )

                                    :


                                    item.frequency_status === "1" && item.frequency_optional_chargebasis_id ? (

                                      <select
                                        name="frequency"
                                        className="form-select fs-8"
                                        onChange={(e) => handleChangeChargeBasis(e, item, index)}
                                      >
                                        {item.ServiceChargeBases.map((chargeBase) => (
                                          // console.log("chargeBase", chargeBase),
                                          chargeBase.ChargeBasis.BasisType.id === 4 ? null : (
                                            <option
                                              key={chargeBase.id}
                                              value={chargeBase.ChargeBasis.id}
                                              selected={
                                                item.sell_chargebasis_id != undefined ? item.sell_chargebasis_id === chargeBase.ChargeBasis.id :
                                                  chargeBase.ChargeBasis.id === item.frequency_optional_chargebasis_id
                                              }
                                            >
                                              {chargeBase.ChargeBasis.name}
                                            </option>
                                          )
                                        ))}
                                      </select>

                                    )

                                      :



                                      (
                                        "-"
                                      )}
                              </td>
                              {/* <td className="fs-14">{item.price}</td> */}
                              {/* <td className="fs-14">
                                {
                                  (() => {
                                    const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                    const matched = item.ServiceChargeBases.find(chargeBase =>
                                      chargeBase.ChargeBasis.id === basisId &&
                                      chargeBase.ChargeBasis.BasisType.id === 2
                                    );
                                    return matched ? (matched?.price_rate).toFixed(2) : item?.price.toFixed(2);
                                  })()
                                }
                              </td> */}
                              <td className="fs-14">
                                {
                                  (() => {
                                    const basisId = item.sell_chargebasis_id || item.default_chargebasis_id;
                                    const matched = item.ServiceChargeBases.find(chargeBase =>
                                      chargeBase.ChargeBasis.id === basisId &&
                                      chargeBase.ChargeBasis.BasisType.id === 2
                                    );

                                    return matched
                                      ? (matched?.price_rate).toFixed(2)
                                      : (item.price + (item.price * increasePremiumFinal / 100)).toFixed(2);
                                  })()
                                }
                              </td>


                              <td className="fs-14 text-center">
                                <Trash2 style={{ color: "red" }}
                                  onClick={() => handleDeleteService(index)}
                                />
                              </td>
                            </tr>
                          ))

                      }


                      {/* Total Cost Calculation  */}


                      {
                        packageID != null || addedService.length > 0 ?
                          <>

                            <tr><td colSpan="2"><strong className="text-pink">Total Cost of Services</strong></td><td><span className="text-pink">&pound;{totalCost.toFixed(2)}</span></td></tr>

                            <tr>
                              <td colSpan="2">Discount (%)</td><td><input type="text" name="discount" min={0}
                                value={discount} onChange={(e) => InputChangeDiscountPremium(e)}
                                className="form-control" />
                                {
                                  errorDiscount ? <span className="text-danger">Discount can not be less than {packageDefaultDiscount}</span> : ""
                                }

                              </td>
                            </tr>


                            <tr><td colSpan="2">Premium (%)</td><td><input type="text" name="premium"
                              value={premium} onChange={(e) => InputChangeDiscountPremium(e)}
                              className="form-control" /></td></tr>


                            <tr><td colSpan="2"> <strong className="text-pink">Annual investment</strong></td><td><span className="text-pink">&pound;{
                              totalCostWithDiscount.toFixed(2)
                              // (Math.trunc(totalCostWithDiscount * 100) / 100).toFixed(2)

                            }</span></td></tr>

                            {/* <tr><td colSpan="2">Net @20% VAT</td><td>&pound;{netVAT20.toFixed(2)}</td></tr>
                            <tr><td colSpan="2">Net @No VAT</td><td>&pound;{netNoVAT.toFixed(2)}</td></tr> */}
                            <tr><td colSpan="2">VAT @20%</td><td>&pound;{vat.toFixed(2)}</td></tr>
                            <tr><td colSpan="2"><strong className="text-pink">Total (including VAT)</strong></td><td><span className="text-pink">&pound;{
                              totalIncludingVAT.toFixed(2)
                              // (Math.trunc(totalIncludingVAT * 100) / 100).toFixed(2)
                            }</span></td></tr>
                            <tr><td colSpan="2">Payment Terms</td>

                              <td>
                                <select
                                  className="form-select"
                                  value={paymentTerm}
                                  onChange={(e) => {
                                    setPaymentTerm(e.target.value);
                                    paymentTermModal(e);
                                  }}
                                >
                                  <option value=""> -- Select Payment Term -- </option>
                                  {
                                    containsGoCardless ?
                                      <>
                                        <option value="monthly_dd">Monthly DD (Direct Debit via GoCardless)</option>
                                        <option value="quarterly_dd">Quarterly DD (Direct Debit via GoCardless)</option>
                                      </>
                                      :
                                      ""
                                  }

                                  <option value="100_upfront" >100% Upfront
                                    {paymentTerm === "100_upfront" && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}
                                  </option>
                                  <option value="50_upfront">50% Upfront / 50% on Draft Submission

                                    {paymentTerm === "50_upfront" && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}
                                  </option>
                                  <option value="100_post_completion" >100% Post Completion
                                    {paymentTerm === "100_post_completion" && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}
                                  </option>
                                  {
                                    serviceTypeForQuote == "1" ?
                                      <>
                                        <option value="manual_payment_monthly">Manual Payment-Monthly
                                          {paymentTerm === "manual_payment_monthly" && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}
                                        </option>
                                        <option value="manual_payment_quarterly">Manual Payment- Quarterly
                                          {paymentTerm === "manual_payment_quarterly" && paymentTypeLable != undefined ? `( ${paymentTypeLable} )` : ""}
                                        </option>
                                      </>
                                      :
                                      ""
                                  }
                                </select>
                              </td>
                            </tr>

                            {
                              paymentTerm != "" ?
                                <>

                                  {['manual_payment_monthly', 'manual_payment_quarterly'].includes(paymentTerm) && Number(agentConfigSetting.admin_charge) === 1 ?
                                    <tr><td colSpan="2">Admin Charge (for Non-DD clients)</td><td>&pound;{adminCharge.toFixed(2)}</td></tr>
                                    :
                                    ""
                                  }


                                  <tr>
                                    <td colSpan="2">
                                      <strong className="text-pink">
                                        {{
                                          monthly_dd: "Total Monthly Cost",
                                          manual_payment_monthly: "Total Monthly Cost",
                                          quarterly_dd: "Total Quarterly Cost",
                                          manual_payment_quarterly: "Total Quarterly Cost",
                                          "100_upfront": "Total Upfront Payment (100%)",
                                          "100_post_completion": "Total Upfront Payment (100%)",
                                          "50_upfront": "Total Upfront Payment (50%)",
                                        }[paymentTerm] || "Total Monthly Cost"} (including VAT)
                                      </strong>
                                    </td>

                                    <td><span className="text-pink">&pound;{totalMonthlyCost.toFixed(2)}</span></td>
                                  </tr>
                                </>
                                :
                                ""
                            }



                          </>

                          : ""
                      }

                    </tbody>

                  </table>

                </div>
              </div>
            </div>
            : ""
          // <------  Service Ongoing And One-Off Selection
        }



      </div>
      <div className="d-flex justify-content-between mt-3">
        {currentStep > 1 && (
          <button className="btn btn-secondary" onClick={prevStep}>
            Previous
          </button>
        )}
        <button
          className="btn btn-pink"
          onClick={handleSubmit}
        >
          {currentStep < 4 ? "Next" : "Submit"}
        </button>
      </div>




      {/* Modal for Preview */}
      {showModalPaymentTerm && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment Terms :
                  {{
                    monthly_dd: "Monthly DD (Direct Debit via GoCardless)",
                    manual_payment_monthly: "Manual Payment-Monthly",
                    quarterly_dd: "Quarterly DD (Direct Debit via GoCardless)",
                    manual_payment_quarterly: "Manual Payment- Quarterly",
                    "100_upfront": "100% Upfront",
                    "100_post_completion": "100% Post Completion",
                    "50_upfront": "50% Upfront / 50% on Draft Submission",
                  }[paymentTerm] || ""}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <p>Select Payment Method</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <select
                      className="form-select"
                      value={paymentTypeOfModal}
                      onChange={(e) => {
                        setPaymentTypeOfModal(e.target.value);
                      }}
                    >
                      {
                        paymentTermTypeGetAgent.length > 0 ?
                          paymentTermTypeGetAgent.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))
                          :
                          ""
                      }
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-pink"
                  onClick={handleCloseModal}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



    </div>

  );
};

export default StepTwo;
